import { serverTimeFunc } from '@/utils/serverTime'

const pad = (n, l, c, r, b) => {
    var s = n.toString(),
        l = l || 2,
        r = r !== false,
        b = b !== false;
    if (s.length > 0) {
        var p = "";
        if (!isNaN(n) && s.charAt(0) == "-") {
            p = "-";
            s = s.substring(1);
        }
        while (s.length < l) {
            if (r) s = (c || "0") + s;
            else s += c || "0";
        }
        return b ? p + s : s;
    } else return "";
}
// cms: backend
const STAFF_MODEL = { // staff_data
    "name": "name",
    "user_type": "staff_role",
    "centers": "center",
    "gender": "gender",
    "username": "username",
    "password": "password_data",
    "phone": "phone",
    "remark": "remark",
};

const CENTER_MODEL = { // center_data
    "name": "name",
    "address": "address",
    "logo": "logo",
    "center_code": "center_code",
    "invoice_terms": "terms",
};

const ROOM_MODEL = { // facility_data
    "name": "name",
    "center_id": "center_id",
};

const PACKAGE_CATEGORY_MODEL = { // package_category_data
    "name": "category_name",
    "code": "package_category_code",
};

const PACKAGE_MODEL = { // package_data
    "code": "package_code",
    "name": "package_name",
    "price": "price",
    "centers": "center",
    "type": "type", // dollar | credit | month
    "days": "days", // expiry days
    "add_credit": "add_credit",
    "add_dollar": "add_dollar",
    "category_id": "package_category_id",
    /** (for type "month"), 不變的, 組合
     * Array<{
     *  "service_count": 0, // 一個月可以用n次療程
     *  "service_list": Array<course_id>
     * // n項服務per treatment
     * // 通常得一個object
     * // Order 入面的 "quota" -> "service_detail_list" 會跟service_count copy -> Array<Array<object, object...>>
     *  "service_detail_list": Array<{course_category_id: -1, course_id: -1, quota: 0, used_count: 0, used: false, lesson: -1}>,
     * // n項[tag]服務per month
     *  "upgrade_service_list":  Array<{course_category_id: -1, course_id: -1, quota: 0, used_count: 0, lessons: []}>
     * }>
     * */
    "set": "set",
    /** (for type "dollar" or "credit")
     * 可選服務
     * Array<{course_category_id: -1, course_id: -1}>
     * */
    "package_service_set": "package_set"

};

const SERVICE_CATEGORY_MODEL = { // course_category_data, service_category_data
    "name": "name",
    "category_code": "category_code",
};

const SERVICE_MODEL = { // course_data
    "code": "course_code",
    "name": "name",
    "category_id": "course_category_id",
    "credit": "credit",
    "dollar": "dollar",
    "duration": "duration", // in second
    "general_service_category_id_list": "service_category_id_list"
};

const PRODUCT_CATEGORY_MODEL = { // category_data
    "name": "name",
};

const PRODUCT_MODEL = { // product_data
    "name": "name",
    "product_code": "product_code",
    "status": "status",
    "category_id": "category",
    "inventory": "inventory",
    "price": "price",
    "cost": "cost",
    "centers": "center_id"
};

const PRODUCT_INVENTORY_MODEL = {
    "date": "date",
    "product_id": "product_id",
    "amount": "count",
    "order_id": "order_id",
    "staff_id": "staff_id",
    "resource": "from"
}

const CUSTOMER_MODEL = { // student_data
    "status": "status",
    "user_code": "student_code",
    "remark": "remark",
    "apply_date": "apply_date",
    "customer_name": "student_name",
    "customer_eng_name": "student_name_en",
    "phone": "phone",
    "address": "address",
    "birth_date": "birthday",
    "gender": "gender",
    "username": "username",
    "password": "password_data",
    "contact_person_1_name": "contact_1_name",
    "contact_person_1_phone": "contact_1_phone",
    "contact_person_2_name": "contact_2_name",
    "contact_person_2_phone": "contact_2_phone",
    "member_level": "level",
    "center_id": "center_id",
    "sign": "sign",
    "follow_up": "follow_up",
};

const BOOKING_MODEL = { // lesson_data
    "code": "course_code",
    "date": "date",
    "start_time": "start_time",
    "end_time": "end_time",
    "color": "color",
    "staff_id": "staff_id",
    "room_id": "facility_id",
    "use_type": "use_type",
    "service_id_list": "course_included",
    "attendance_list": "attendance", // { student_id: -1, status: 'pending' | 'attend' | 'absent', sign_img: '', sign_datetime: '' }
    "center_id": "center_id",
    "user_id_list": "students",
    "staff_list": "course_staff"
}

const ORDER_MODEL = { // order_data / payment_order_data
    "center_id": "center_id",
    "discount_type": "discount_type",
    "discount_value": "discount_value",
    "end_date": "end_date",
    "package_id": "package_id",
    "package_id_list": "package_id_list",
    "payment_image": "payment_image",
    "payment_method": "payment_method",
    "product_id_list": "product_id_list",
    "remark": "remark",
    "start_date": "start_date",
    "status": "status",
    "payment_status": "payment_status",
    "user_id": "student_id",
    "subtotal": "subtotal",
    "staffs": "staffs",
    "payment_records": "payment_records"
};

const convertCMSKeyToBackendKey = (payload, model) => {
    if (payload && Object.keys(payload).length > 0) {
        let obj = {};

        for (const key in payload) {
            if (model[key] !== undefined && model[key] !== null && model[key] !== '') {
                obj[model[key]] = payload[key];
            } else {
                obj[key] = payload[key];
            }
        }

        return obj;
    }

    return {};
}

// backend: cms
const CMS_USER_STATUS = {
    "active": "active",
    "quit": "inactive"
}

const CMS_ORDER_STATUS = {
    "pending": "pending",
    "paid": "paid",
    "expired": "expired",
    "cancelled": "cancelled",
    "null": "null",
    "processing": "processing",
    "debit": "debit", // refund
    "void": "void",
    "partially_paid": "partially_paid",
}

const CMS_ATTENDANCE_STATUS = {
    "pending": "pending",
    "attend": "attend",
    "absent": "absent",
    "reschedule": "reschedule",
    "drop": "drop",
    "swap": "swap",
    "skip": "skip"
}

const CMS_PRODUCT_INVENTORY_SOURCE = {
    "order debit": "debit",
    "order void": "void",
    "staff": "staff",
    "order": "order"
}

const AGREEMENT_MODEL = { // agreement_data
    "name": "name",
    "content": "content",
    "center": "center",
    "remark": "remark",
    "status": "status"
}

const AGREEMENT_SIGN_MODEL = { // agreement_sign_data
    "student_id": "student_id",
    "sign_datetime": "sign_datetime",
    "sign_img": "sign_img",
    "agreement_id": "agreement_id",
    "name": "name",
    "content": "content",
    "remark": "remark",
    "company_sign_img": "company_sign_img"
}

const SHIFT_CODE_MODEL = { // shift_data
    "status": "status",
    "code": "code",
    "color": "color",
    "order": "order",
    "center": "center",
    "time_list": "time_list"
}

const SHIFT_SETTING_MODEL = {
    "shift_date": "shift_date",
    "year": "year",
    "month": "month",
    "shift_id": "shift_id",
    "shift_type": "shift_type",
    "staff_id": "staff_id",
    "custom_time_list": "custom_time_list"
}


const parseStaffData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            create_date: data.create_date,
            name: data[STAFF_MODEL.name],
            user_type: data[STAFF_MODEL.user_type],
            centers: data[STAFF_MODEL.centers] || [],
            gender: data[STAFF_MODEL.gender],
            username: data[STAFF_MODEL.username],
            phone: data[STAFF_MODEL.phone],
            remark: data[STAFF_MODEL.remark],
        };
    }

    return null;
}

const parseCenterData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            name: data[CENTER_MODEL.name],
            address: data[CENTER_MODEL.address],
            logo: data[CENTER_MODEL.logo],
            center_code: data[CENTER_MODEL.center_code],
            invoice_terms: data[CENTER_MODEL.invoice_terms],
            custom_text: data.custom_text,
            phone: data.phone,
            email: data.email,
            member_terms_field: data.member_terms_field,
        };
    }

    return null;
}

const parseRoomData = (data, centerData = []) => {
    if (data) {
        let targetCenterData = null;
        if (centerData.length > 0) {
            targetCenterData = centerData.find(el => el.id === data[ROOM_MODEL.center_id]);
        }
        return {
            id: data.id,
            active: data.active,
            name: data[ROOM_MODEL.name],
            center_id: data[ROOM_MODEL.center_id],
            center_data: targetCenterData
        };
    }

    return null;
}

const parseServiceCategoryData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            name: data[SERVICE_CATEGORY_MODEL.name],
            category_code: data[SERVICE_CATEGORY_MODEL.category_code],
        };
    }

    return null;
}

const parseServiceData = (data, categoryData = [], generalServiceCategoryData = []) => {
    if (data) {
        let targetCate = null;
        if (categoryData.length > 0) {
            targetCate = categoryData.find(el => el.id === data[SERVICE_MODEL.category_id]);
        }

        let generalServiceCate = []
        if (generalServiceCategoryData.length > 0) {
            const idList = data[SERVICE_MODEL.general_service_category_id_list] || [];

            generalServiceCate = generalServiceCategoryData.filter(obj => {
                return idList.includes(obj.id)
            })
        }

        return {
            id: data.id,
            active: data.active,
            name: data[SERVICE_MODEL.name],
            category_id: data[SERVICE_MODEL.category_id],
            credit: data[SERVICE_MODEL.credit] !== true ? data[SERVICE_MODEL.credit] : 0,
            dollar: data[SERVICE_MODEL.dollar] !== true ? data[SERVICE_MODEL.dollar] : 0,
            duration: data[SERVICE_MODEL.duration] !== true ? data[SERVICE_MODEL.duration] : 0,
            code: data[SERVICE_MODEL.code] || '',
            general_service_category_id_list: data[SERVICE_MODEL.general_service_category_id_list] || [],
            // extra
            category_data: targetCate,
            general_service_category_list: generalServiceCate,
        }
    }

    return null;
}

const parsePackageCategoryData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            name: data[PACKAGE_CATEGORY_MODEL.name],
            code: data[PACKAGE_CATEGORY_MODEL.code],
        };
    }

    return null;
}

const parsePackageData = (data, categoryData = [], serviceCategoryData = []) => {
    if (data) {
        const set = [];
        if (data[PACKAGE_MODEL.set] && data[PACKAGE_MODEL.set].length) {
            data[PACKAGE_MODEL.set].forEach(item => {
                let service_count_per_treatment = 0;
                let tag_service_category = -1;
                let tag_service_count = 0;
                let tag_service_category_name = '';

                if (item.service_detail_list?.length) {
                    const found = item.service_detail_list.find(el => el.course_category_id === -1);
                    if (found) {
                        service_count_per_treatment = found.quota;
                    }
                }

                if (item.upgrade_service_list?.length) {
                    tag_service_category = item.upgrade_service_list[0].course_category_id;
                    tag_service_count = item.upgrade_service_list[0].quota;

                    const foundTag = serviceCategoryData.find(el => el.id === tag_service_category);
                    if (foundTag) {
                        tag_service_category_name = foundTag.name;
                    }
                }
                set.push({
                    ...item,
                    service_count_per_treatment,
                    tag_service_category,
                    tag_service_count,
                    tag_service_category_name
                })
            })
        }

        const packageServiceSet = [];
        if (data[PACKAGE_MODEL.package_service_set] && data[PACKAGE_MODEL.package_service_set].length) {
            for (let i = 0; i < data[PACKAGE_MODEL.package_service_set].length; i++) {
                if (data[PACKAGE_MODEL.package_service_set][i].course_id !== -1) {
                    packageServiceSet.push(data[PACKAGE_MODEL.package_service_set][i].course_id)
                }
            }
        }

        const foundCategory = categoryData.find(el => el.id === data[PACKAGE_MODEL.category_id]);

        return {
            id: data.id,
            active: data.active,
            name: data[PACKAGE_MODEL.name],
            price: data[PACKAGE_MODEL.price],
            centers: data[PACKAGE_MODEL.centers],
            type: data[PACKAGE_MODEL.type],
            days: data[PACKAGE_MODEL.days],
            add_credit: data[PACKAGE_MODEL.add_credit],
            add_dollar: data[PACKAGE_MODEL.add_dollar],
            code: data[PACKAGE_MODEL.code] || '',
            category_id: data[PACKAGE_MODEL.category_id] !== undefined ? data[PACKAGE_MODEL.category_id] : -1,
            set: set,
            package_service_set: packageServiceSet,
            // -- extra
            raw_package_data: data,
            months: Math.ceil(data[PACKAGE_MODEL.days] / 30),
            category_name: foundCategory ? foundCategory.name : '',
        };
    }

    return null;
}

const parseProductCategoryData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            name: data[PRODUCT_CATEGORY_MODEL.name],
        };
    }

    return null;
}

const parseProductData = (data, categoryData = []) => {
    if (data) {
        let targetCate = null;
        if (categoryData.length > 0) {
            targetCate = categoryData.find(el => el.id === data[PRODUCT_MODEL.category_id]);
        }

        return {
            id: data.id,
            active: data.active,
            status: data.status, // 'active' | 'inactive'
            name: data[PRODUCT_MODEL.name],
            product_code: data[PRODUCT_MODEL.product_code],
            centers: data[PRODUCT_MODEL.centers],
            category_id: data[PRODUCT_MODEL.category_id],
            category_data: targetCate,
            inventory: data[PRODUCT_MODEL.inventory],
            price: data[PRODUCT_MODEL.price],
            cost: data[PRODUCT_MODEL.cost],
        };
    }

    return null;
}

const parseProductInventoryData = (data, staffData = [], orderData = []) => {
    if (data) {
        let foundStaff = staffData.find(el => el.id === data[PRODUCT_INVENTORY_MODEL.staff_id]);

        let foundOrder = null;
        if (data[PRODUCT_INVENTORY_MODEL.resource] === 'order debit') {
            foundOrder = orderData.find(el => el.id === data[PRODUCT_INVENTORY_MODEL.order_id]);
        } else {
            for (let i = 0; i < orderData.length; i++) {
                for (let j = 0; j < orderData[i].orders.length; j++) {
                    if (orderData[i].orders[j].id === data[PRODUCT_INVENTORY_MODEL.order_id]) {
                        foundOrder = orderData[i];
                        break;
                    }
                }
                if (foundOrder) break;
            }
        }

        return {
            id: data.id,
            active: data.active,
            product_id: data[PRODUCT_INVENTORY_MODEL.product_id],
            amount: data[PRODUCT_INVENTORY_MODEL.amount],
            order_id: data[PRODUCT_INVENTORY_MODEL.order_id],
            staff_id: data[PRODUCT_INVENTORY_MODEL.staff_id],
            date: data[PRODUCT_INVENTORY_MODEL.date] ? data[PRODUCT_INVENTORY_MODEL.date] : data.create_date.substring(0, 10),

            // extra
            staff_name: foundStaff ? foundStaff.name : '',
            resource: CMS_PRODUCT_INVENTORY_SOURCE[data[PRODUCT_INVENTORY_MODEL.resource]] || '',
            order_code: foundOrder ? foundOrder.order_code : ''
        };
    }

    return null;
}


const parseCustomerData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            status: CMS_USER_STATUS[data.status] || 'active', // active | quit
            customer_name: data[CUSTOMER_MODEL.customer_name] || '', // required
            customer_eng_name: data[CUSTOMER_MODEL.customer_eng_name] || '',
            address: data[CUSTOMER_MODEL.address] || '',
            gender: data[CUSTOMER_MODEL.gender] || '',
            phone: data[CUSTOMER_MODEL.phone] || '', // required
            birth_date: data[CUSTOMER_MODEL.birth_date] || '', // YYYY-MM-DD
            username: data[CUSTOMER_MODEL.username] || '',
            contact_person_1_name: data[CUSTOMER_MODEL.contact_person_1_name],
            contact_person_1_phone: data[CUSTOMER_MODEL.contact_person_1_phone],
            contact_person_2_name: data[CUSTOMER_MODEL.contact_person_2_name],
            contact_person_2_phone: data[CUSTOMER_MODEL.contact_person_2_phone],
            member_level: data[CUSTOMER_MODEL.member_level] || '',
            remark: data[CUSTOMER_MODEL.remark] || '',
            user_code: data[CUSTOMER_MODEL.user_code] || '',
            apply_date: data[CUSTOMER_MODEL.apply_date] || '',
            center_id: data[CUSTOMER_MODEL.center_id],
            // terms_field: data[CUSTOMER_MODEL.terms_field] || '',
            sign: data[CUSTOMER_MODEL.sign] || '',
            follow_up: data[CUSTOMER_MODEL.follow_up] || '',

            reg_date: data.create_date ? data.create_date.substring(0, 10) : '',
        };
    }

    return null;
}

const parsePayTuitionData = (data) => {
    if (data) {
        return {
            user_id: data.id,
            customer_name: data[CUSTOMER_MODEL.customer_name] || '',
            gender: data[CUSTOMER_MODEL.gender] || '',
            phone: data[CUSTOMER_MODEL.phone] || '',
            reg_date: data.create_date ? data.create_date.substring(0, 10) : '',
            user_code: data[CUSTOMER_MODEL.user_code],
            center_id: data[CUSTOMER_MODEL.center_id]
        };
    }

    return null;
}

const parseBookingData = (data, serviceData = [], userData = [], staffData = []) => {
    if (data) {
        const user_id = data[BOOKING_MODEL.user_id_list] && data[BOOKING_MODEL.user_id_list].length > 0 ? data[BOOKING_MODEL.user_id_list][0] : -1;

        let attend_status = 'pending';
        let sign_img = '';
        let sign_datetime = '';
        if (data[BOOKING_MODEL.attendance_list] && data[BOOKING_MODEL.attendance_list].length) {
            attend_status = data[BOOKING_MODEL.attendance_list][0].status;
            sign_img = data[BOOKING_MODEL.attendance_list][0].sign_img;
            sign_datetime = data[BOOKING_MODEL.attendance_list][0].sign_datetime;
        }
        if (data.exit && data.exit.includes(user_id) || !data.active) {
            attend_status = 'drop';
        }
        let service_data_list = [];
        if (serviceData && data[BOOKING_MODEL.service_id_list]) {
            service_data_list = serviceData.filter(el => data[BOOKING_MODEL.service_id_list].includes(el.id));
        }

        let staff_list = data[BOOKING_MODEL.staff_list] || [];
        if (staff_list.length < 0 && data[BOOKING_MODEL.staff_id] !== undefined && data[BOOKING_MODEL.staff_id] !== null && data[BOOKING_MODEL.staff_id] > -1) {
            const service_id_list = data[BOOKING_MODEL.service_id_list] || [];
            for (let i = 0; i < service_id_list.length; i++) {
                staff_list.push({ course_id: service_id_list[i], staff_id: data[BOOKING_MODEL.staff_id] })
            }
        }
        const staff_data_list = [];
        if (staff_list.length) {
            for (let i = 0; i < staff_list.length; i++) {
                const found = staffData.find(el => el.id === staff_list[i].staff_id);
                if (found) {
                    const exists = staff_data_list.findIndex(el => {
                        return el.id === found.id
                    })

                    if (exists === -1) {
                        staff_data_list.push(found);
                    }
                }
            }
        }

        return {
            id: data.id,
            active: data.active,
            code: data[BOOKING_MODEL.code],
            date: data[BOOKING_MODEL.date],
            start_time: data[BOOKING_MODEL.start_time],
            end_time: data[BOOKING_MODEL.end_time],
            color: data[BOOKING_MODEL.color],
            staff_list: staff_list,
            room_id: data[BOOKING_MODEL.room_id],
            room_data: data.facility_data ? data.facility_data : null,
            use_type: data[BOOKING_MODEL.use_type] === 'package' ? 'month' : data[BOOKING_MODEL.use_type],
            service_id_list: data[BOOKING_MODEL.service_id_list] || [],
            center_id: data[BOOKING_MODEL.center_id],
            attendance_list: data[BOOKING_MODEL.attendance_list],

            service_data_list: service_data_list,
            attend_status: CMS_ATTENDANCE_STATUS[attend_status] || 'pending',
            user_id: user_id,
            staff_data_list: staff_data_list,
            user_data: userData.find(el => el.id === user_id),
            sign_img: sign_img,
            sign_datetime: sign_datetime,
            order_id: data.order_id,
            package_id: data.package_id,
            limit_start_date: data.limit_start_date,
            limit_end_date: data.limit_end_date
        }
    }

    return null;
}

const parseOrderGroupData = (data, centerData = []) => {
    if (data) {
        let order_status = CMS_ORDER_STATUS[data.status] || 'pending';
        if (data.status === 'paid' && data.payment_status) {
            order_status = CMS_ORDER_STATUS[data.payment_status];
        }

        let orders = [];
        if (data.orders_datas && Array.isArray(data.orders_datas) && data.orders_datas.length > 0) {
            orders = data.orders_datas.map(parseOrderData);
        } else if (data.orders && Array.isArray(data.orders) && data.orders.length > 0) {
            orders = data.orders.map(parseOrderData);
        }

        let order_type = [];
        let real_total = orders[0] ? orders[0].subtotal : 0;
        let qty = 0;
        const order_items = [];

        let refund_value = 0
        let refund_dollar = 0

        orders.forEach(order => {
            order.order_type.forEach(type => {
                if (!order_type.includes(type)) {
                    order_type.push(type);
                }
            })

            if (order.is_upgrade) {
                real_total += order.upgrade_records.reduce((value, item) => value + item.fee, 0);
            }

            if (order.order_type.includes('package')) {
                qty += 1;
                order_items.push(order.package_name)

                if (order.refund_value !== undefined && order.refund_value !== null && !isNaN(order.refund_value)) {
                    if (order.package_type === 'credit') {
                        refund_value += parseFloat(order.refund_value)
                    } else if (order.package_type === 'dollar') {
                        refund_dollar += parseFloat(order.refund_value)
                    }

                    if (order.upgrade_records && order.credit_dollar_upgrade_list) {
                        order.upgrade_records.forEach(upgradeItem => {
                            if (upgradeItem.credit_dollar_upgrade_id && upgradeItem.credit_dollar_upgrade_id !== -1) {
                                const upgradeData = order.credit_dollar_upgrade_list.find(el => { return el.id === upgradeItem.credit_dollar_upgrade_id })
                                if (upgradeData) {
                                    if (upgradeData.type === 'credit') {
                                        refund_value += parseFloat(upgradeItem.refund_value || 0);
                                    } else if (upgradeData.type === 'dollar') {
                                        refund_dollar += parseFloat(upgradeItem.refund_value || 0);
                                    }
                                }
                            }
                        })
                    }
                }

            }
        })

        let balance = real_total;
        if (orders[0]) {
            const paid_total = orders[0].payment_records.reduce((value, invoice) => value + invoice.amount, 0);
            balance = real_total - paid_total;
            if (balance < 0) balance = 0;

            if (orders[0].order_type.includes('product')) {
                orders[0].product_datas.forEach(item => {
                    order_items.push(item.name);
                })
                qty += orders[0].product_list.reduce((count, item) => count + item.amount, 0);
            }
        }

        let customer_name = data.student_data ? (data.student_data[CUSTOMER_MODEL.customer_name] || data.student_data[CUSTOMER_MODEL.customer_eng_name]) : '';
        if (!customer_name && orders[0]) {
            customer_name = orders[0].customer_name
        }

        let user_code = data.student_data ? (data.student_data[CUSTOMER_MODEL.user_code] || "") : '';
        if (!user_code && orders[0]) {
            user_code = orders[0].user_code
        }

        const center_id = orders[0] ? orders[0].center_id : -1;
        let orderCode = pad(data.id, 4);
        const foundCenter = centerData.find(el => el.id === center_id);
        if (foundCenter) {
            orderCode = `${foundCenter.center_code}-${orderCode}`;
        }


        return {
            id: data.id,
            active: data.active,
            create_date: data.create_date ? `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 19)}` : '',
            status: order_status, // 睇呢個為準
            package_id_list: data[ORDER_MODEL.package_id_list],
            orders: orders, // 睇第一個order為準(除左refund_value)
            order_code: orderCode,
            // from orders[0]
            user_id: orders[0] ? orders[0].user_id : -1,
            center_id: center_id,
            subtotal: orders[0] ? orders[0].subtotal : 0,
            discount_type: orders[0] ? orders[0].discount_type : '',
            discount_value: orders[0] ? orders[0].discount_value : 0,
            product_list: orders[0] ? orders[0].product_list : [],
            product_datas: orders[0] ? orders[0].product_datas : [],
            package_type: orders[0] ? orders[0].package_type : '',
            package_type_arr: orders.length > 0 ? [...new Set(orders.map(obj => { return obj.package_type }))] : [],
            remark: orders[0] ? orders[0].remark : '',
            staffs: orders[0] ? orders[0].staffs : [],
            order_type: order_type,
            month: orders[0] ? orders[0].month : '',
            customer_name: customer_name,
            user_code: user_code,
            payment_records: orders[0] ? orders[0].payment_records : [],
            raw_payment_records: orders[0] ? orders[0].raw_payment_records : [],
            balance: balance,
            order_items: order_items,
            qty: qty,
            real_total: real_total,
            main_order_id: orders[0] ? orders[0].id : -1,
            // -- 退款
            debit_product_ids: orders[0] ? orders[0].debit_product_ids : [],
            debit_amount: orders[0] ? orders[0].debit_amount : 0,
            debit_remark: orders[0] ? orders[0].debit_remark : '',
            refund_value: order_status === 'debit' ? refund_value : undefined,
            refund_dollar: order_status === 'debit' ? refund_dollar : undefined,
        }
    }

    return null;
}

const parseMonthOrderGroupData = (data, centerData = []) => {
    if (data) {
        let order_status = CMS_ORDER_STATUS[data.status] || 'pending';
        if (data.status === 'paid' && data.payment_status) {
            order_status = CMS_ORDER_STATUS[data.payment_status];
        }

        let orders = [];
        if (data.orders_datas && Array.isArray(data.orders_datas) && data.orders_datas.length > 0) {
            orders = data.orders_datas.map(parseOrderData);
        } else if (data.orders && Array.isArray(data.orders) && data.orders.length > 0) {
            orders = data.orders.map(parseOrderData);
        }

        let order_type = [];
        let real_total = orders[0] ? orders[0].subtotal : 0;
        let qty = 0;
        const order_items = [];

        let refund_value = 0
        let refund_dollar = 0

        orders.forEach(order => {
            order.order_type.forEach(type => {
                if (!order_type.includes(type)) {
                    order_type.push(type);
                }
            })

            if (order.is_upgrade) {
                real_total += order.upgrade_records.reduce((value, item) => value + item.fee, 0);
            }

            if (order.order_type.includes('package')) {
                qty += 1;
                order_items.push(order.package_name)

                if (order.refund_value !== undefined && order.refund_value !== null && !isNaN(order.refund_value)) {
                    if (order.package_type === 'credit') {
                        refund_value += parseFloat(order.refund_value)
                    } else if (order.package_type === 'dollar') {
                        refund_dollar += parseFloat(order.refund_value)
                    }

                    if (order.upgrade_records && order.credit_dollar_upgrade_list) {
                        order.upgrade_records.forEach(upgradeItem => {
                            if (upgradeItem.credit_dollar_upgrade_id && upgradeItem.credit_dollar_upgrade_id !== -1) {
                                const upgradeData = order.credit_dollar_upgrade_list.find(el => { return el.id === upgradeItem.credit_dollar_upgrade_id })
                                if (upgradeData) {
                                    if (upgradeData.type === 'credit') {
                                        refund_value += parseFloat(upgradeItem.refund_value || 0);
                                    } else if (upgradeData.type === 'dollar') {
                                        refund_dollar += parseFloat(upgradeItem.refund_value || 0);
                                    }
                                }
                            }
                        })
                    }
                }

            }
        })

        let balance = real_total;
        if (orders[0]) {
            const paid_total = orders[0].payment_records.reduce((value, invoice) => value + invoice.amount, 0);
            balance = real_total - paid_total;
            if (balance < 0) balance = 0;

            if (orders[0].order_type.includes('product')) {
                orders[0].product_datas.forEach(item => {
                    order_items.push(item.name);
                })
                qty += orders[0].product_list.reduce((count, item) => count + item.amount, 0);
            }
        }

        let customer_name = data.student_data ? (data.student_data[CUSTOMER_MODEL.customer_name] || data.student_data[CUSTOMER_MODEL.customer_eng_name]) : '';
        if (!customer_name && orders[0]) {
            customer_name = orders[0].customer_name
        }

        let user_code = data.student_data ? (data.student_data[CUSTOMER_MODEL.user_code] || "") : '';
        if (!user_code && orders[0]) {
            user_code = orders[0].user_code
        }

        const center_id = orders[0] ? orders[0].center_id : -1;
        let orderCode = pad(data.id, 4);
        const foundCenter = centerData.find(el => el.id === center_id);
        if (foundCenter) {
            orderCode = `${foundCenter.center_code}-${orderCode}`;
        }


        return {
            id: data.id,
            active: data.active,
            create_date: data.create_date ? `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 19)}` : '',
            end_date: data.end_date ? `${data.end_date.substring(0, 10)} ${data.end_date.substring(11, 19)}` : '',
            status: order_status, // 睇呢個為準
            package_id_list: data[ORDER_MODEL.package_id_list],
            orders: orders, // 睇第一個order為準(除左refund_value)
            order_code: orderCode,
            // from orders[0]
            user_id: orders[0] ? orders[0].user_id : -1,
            center_id: center_id,
            subtotal: orders[0] ? orders[0].subtotal : 0,
            discount_type: orders[0] ? orders[0].discount_type : '',
            discount_value: orders[0] ? orders[0].discount_value : 0,
            product_list: orders[0] ? orders[0].product_list : [],
            product_datas: orders[0] ? orders[0].product_datas : [],
            package_type: orders[0] ? orders[0].package_type : '',
            package_type_arr: orders.length > 0 ? [...new Set(orders.map(obj => { return obj.package_type }))] : [],
            remark: orders[0] ? orders[0].remark : '',
            staffs: orders[0] ? orders[0].staffs : [],
            order_type: order_type,
            month: orders[0] ? orders[0].month : '',
            customer_name: customer_name,
            user_code: user_code,
            payment_records: orders[0] ? orders[0].payment_records : [],
            raw_payment_records: orders[0] ? orders[0].raw_payment_records : [],
            balance: balance,
            order_items: order_items,
            qty: qty,
            real_total: real_total,
            main_order_id: orders[0] ? orders[0].id : -1,
            // -- 退款
            debit_product_ids: orders[0] ? orders[0].debit_product_ids : [],
            debit_amount: orders[0] ? orders[0].debit_amount : 0,
            debit_remark: orders[0] ? orders[0].debit_remark : '',
            refund_value: order_status === 'debit' ? refund_value : undefined,
            refund_dollar: order_status === 'debit' ? refund_dollar : undefined,
        }
    }

    return null;
}

const parseOrderData = (data) => {
    if (data) {
        const order_type = [];
        let qty = 0;
        const order_items = [];

        if (data.credit_dollar_upgrade_list !== undefined && data.credit_dollar_upgrade_list !== null && Array.isArray(data.credit_dollar_upgrade_list)) {
            order_type.push('package');
            qty += 1;

            const upgradeData = data.credit_dollar_upgrade_list[data.credit_dollar_upgrade_list.length - 1];
            if (upgradeData.package_data) {
                if (data.credit_dollar_upgrade_list.length === 1) {
                    data.old_package_data = data.package_data
                } else {
                    data.old_package_data = data.credit_dollar_upgrade_list[data.credit_dollar_upgrade_list.length - 2].package_data;
                }

                data.original_package_data = data.package_data
                data.package_data = upgradeData.package_data
            }

        } else if (data[ORDER_MODEL.package_id] !== undefined && data[ORDER_MODEL.package_id] !== null && data[ORDER_MODEL.package_id] > -1) {
            order_type.push('package');
            qty += 1;
            if (data.package_data) {
                order_items.push(data.package_data[PACKAGE_MODEL.name]);
            }
        }
        if (Array.isArray(data[ORDER_MODEL.product_id_list]) && data[ORDER_MODEL.product_id_list].length > 0) {
            order_type.push('product');

            if (data.product_datas) {
                data.product_datas.forEach(item => {
                    order_items.push(item[PRODUCT_MODEL.name]);
                })
            }

            qty += data[ORDER_MODEL.product_id_list].reduce((count, item) => count + item.amount, 0);
        }

        const is_upgrade = data.upgrade_fee && data.upgrade_fee.length > 0 ? true : false;

        let real_total = data[ORDER_MODEL.subtotal]; // with upgrade price
        let total_upgrade_fee = 0;
        if (is_upgrade) {
            data.upgrade_fee.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            total_upgrade_fee = data.upgrade_fee.reduce((value, item) => value + item.fee, 0);
            real_total += total_upgrade_fee;
        }


        let order_status = CMS_ORDER_STATUS[data.status] || 'pending';
        if (data.debit_amount !== undefined) {
            order_status = 'debit';
        } else if (data.status === 'paid' && data.payment_status) {
            order_status = CMS_ORDER_STATUS[data.payment_status];
        }

        let payment_records = [];
        let balance = real_total;
        if (data.payment_records) {
            payment_records = JSON.parse(JSON.stringify(data.payment_records)).sort((a, b) => b.index - a.index);

            const paid_total = payment_records.reduce((value, invoice) => value + invoice.amount, 0);
            balance = real_total - paid_total;
        }

        if (balance < 0) {
            balance = 0;
        }

        return {
            id: data.id,
            active: data.active,
            create_date: data.create_date ? `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 19)}` : '',
            status: order_status,
            user_id: data[ORDER_MODEL.user_id],
            center_id: data[ORDER_MODEL.center_id],
            subtotal: data[ORDER_MODEL.subtotal],
            discount_type: data[ORDER_MODEL.discount_type],
            discount_value: data[ORDER_MODEL.discount_value],
            package_id: order_type.includes('package') ? data[ORDER_MODEL.package_id] : -1,
            start_date: data[ORDER_MODEL.start_date],
            end_date: data[ORDER_MODEL.end_date],
            expiry: data.expiry || [],
            quota: data.quota || [],
            package_data: data.package_data,
            product_list: data[ORDER_MODEL.product_id_list],
            payment_image: data[ORDER_MODEL.payment_image], // unused
            payment_method: data[ORDER_MODEL.payment_method], // unused
            remark: data[ORDER_MODEL.remark],
            staffs: data[ORDER_MODEL.staffs] || [],

            order_type: order_type,
            product_datas: data.product_datas ? data.product_datas.map(parseProductData) : [],
            month: data.create_date ? data.create_date.substring(5, 7) : '',
            customer_name: data.student_data ? (data.student_data[CUSTOMER_MODEL.customer_name] || data.student_data[CUSTOMER_MODEL.customer_eng_name]) : '',
            user_code: data.student_data ? (data.student_data[CUSTOMER_MODEL.user_code] || "") : '',
            package_name: data.package_data?.package_name || '',
            package_type: data.package_data?.type || '',
            package_price: data.package_data?.price || 0,
            payment_records: payment_records,
            raw_payment_records: data.payment_records || [],
            balance: balance,
            order_items: order_items,
            qty: qty,

            // -- 退款
            debit_product_ids: data.debit_product_ids,
            debit_amount: data.debit_amount,
            debit_remark: data.debit_remark,
            refund_value: data.refund_value,

            // -- Upgrade
            is_upgrade: is_upgrade,
            upgrade_fee: is_upgrade ? data.upgrade_fee[0].fee : 0, // unused
            upgrade_payment_image: is_upgrade ? data.upgrade_fee[0].payment_image : 0,
            upgrade_payment_method: is_upgrade ? data.upgrade_fee[0].payment_method : 0,
            upgrade_date: is_upgrade ? data.upgrade_fee[0].date : 0,
            upgrade_status: is_upgrade ? (CMS_ORDER_STATUS[data.upgrade_fee[0].payment_status] || 'pending') : 'pending',
            real_total: real_total,
            upgrade_records: data.upgrade_fee,
            total_upgrade_fee: total_upgrade_fee,
            old_package_price: is_upgrade && data.old_package_data ? data.old_package_data.price : 0,
            real_order_total: data.real_order_total ? data.real_order_total : [],
            credit_dollar_upgrade_list: data.credit_dollar_upgrade_list,

            // 剩餘格仔/value數量
            remaining_package_value: data.remaining_package_value,
            // 格仔/value數量
            total_package_value: data.total_package_value,
            per_value: data.per_value
        };
    }

    return null;


    // payment_image 同 payment_method 主要睇最新嘅 payment_records
    // remark 分開睇
    /** 
     * {
     * "discount_type": "percentage" | "fix_amount",
     * "discount_value": 0,
     * "end_date": "", // credit/dollar：default有 ｜ 月票：有用過先有
     * "expiry": [], // 月票：有用過先有
     * "package_data": {},
     * "package_id": -1,
     * "pay_date": "", // status = "paid"時record
     * "payment_image": "", // unused
     * "payment_method": "", // unused
     * "remark": "", // default create嘅時候會跟第一個payment
     * "payment_package_data": {},
     * "payment_records": [
           {
               "amount": 0,
               "date": "",
               "index": 1,
               "payment_image": "",
               "payment_method": "",
               "remark": ""
           }
       ],
       "upgrade_fee": [
            {
                "date": "",
                "fee": 0,
                "payment_image": "",
                "payment_method": "",
                "payment_status": "" // for ref only 會sync出面個payment_status (如果係paid，唔會再改)
                "staffs": []
            }
        ],
        // * order嘅付款狀態
        * Possible case:
        * - status: paid, payment_status: paid
        * - status: paid, payment_status: partially_paid
        * - status: pending, payment_status: pending
        * - status: processing, payment_status: processing
        * - status: void, payment_status: '' (any)
        * - status: debit, payment_status: '' (any)
        * //
       "payment_status": "",
       "product_datas": [],
       "product_id_list": [],
       "quota": [
            {
                "service_detail_list": [
                    [
                        {
                            "course_category_id": -1,
                            "course_id": -1,
                            "quota": 0,
                            // -- used
                            "lesson": -1,
                            "used": true,
                            "used_count": 0
                        }
                    ]
                ],
                "service_list": [],
                "upgrade_service_list": []
            }
        ],
       "staffs": [
           {
               "commission": 0,
               "role": "",
               "staff": -1
           }
       ],
       "start_date": "", // credit/dollar：default有 ｜ 月票：有用過先有
       "status": "", // 決定order嘅月票/套票可唔可以用，"paid" 就可以用
       "student_data": {},
       "student_id": -1,
       "subtotal": 0,
       "type": ""
   } */
}

const parseAgreementData = (data, sign_data = null) => {
    if (data) {
        const result = {
            id: data.id,
            active: data.active,
            create_date: data.create_date,
            name: data[AGREEMENT_MODEL.name] || "",
            content: data[AGREEMENT_MODEL.content] || "",
            center: data[AGREEMENT_MODEL.center] || [],
            remark: data[AGREEMENT_MODEL.remark] || "",
            status: data[AGREEMENT_MODEL.status] || "",
        }

        if (sign_data !== undefined && sign_data !== null) {
            result.sign_data = parseAgreementSignData(sign_data)
        }

        return result;
    }
    return null;
}

const parseAgreementSignData = (data) => {
    if (data) {
        return {
            id: data.id,
            active: data.active,
            create_date: data.create_date,
            student_id: data[AGREEMENT_SIGN_MODEL.student_id] || -1,
            sign_datetime: data[AGREEMENT_SIGN_MODEL.sign_datetime] || "",
            sign_img: data[AGREEMENT_SIGN_MODEL.sign_img] || "",
            agreement_id: data[AGREEMENT_SIGN_MODEL.agreement_id] || -1,
            name: data[AGREEMENT_SIGN_MODEL.name] || "",
            content: data[AGREEMENT_SIGN_MODEL.content] || "",
            remark: data[AGREEMENT_SIGN_MODEL.remark] || "",
            company_sign_img: data[AGREEMENT_SIGN_MODEL.company_sign_img] || "",
        }
    }
    return null;
}

const parseShiftCodeData = (data) => {
    if (data) {
        const result = {
            id: data.id,
            active: data.active,
            create_date: data.create_date,
            status: data[SHIFT_CODE_MODEL.status] || "",
            code: data[SHIFT_CODE_MODEL.code] || "",
            color: data[SHIFT_CODE_MODEL.color] || "#FFFFFF",
            center: data[SHIFT_CODE_MODEL.center] || [],
            order: data[SHIFT_CODE_MODEL.order] || 1,
            time_list: data[SHIFT_CODE_MODEL.time_list] || [],
        }

        return result;
    }
    return null;
}

const parseShiftSettingData = (data) => {
    if (data) {
        const result = {
            id: data.id,
            active: data.active,
            create_date: data.create_date,
            shift_date: data[SHIFT_SETTING_MODEL.shift_date] || "",
            year: data[SHIFT_SETTING_MODEL.year] || "",
            month: data[SHIFT_SETTING_MODEL.month] || "",
            shift_id: data[SHIFT_SETTING_MODEL.shift_id] || -1,
            shift_type: data[SHIFT_SETTING_MODEL.shift_type] || "",
            staff_id: data[SHIFT_SETTING_MODEL.staff_id] || -1,
            custom_time_list: data[SHIFT_SETTING_MODEL.custom_time_list] || [],
        }

        if (data.shift_data !== undefined && data.shift_data !== null && data.shift_data !== "") {
            result.shift_data = parseShiftCodeData(data.shift_data)
        }

        return result;
    }
    return null;
}

const displayError = (res) => {
    if (res.data !== undefined && res.data !== null) {
        if (typeof res.data === 'string') {
            return res.data;
        } else {
            return JSON.stringify(res.data);
        }
    }

    return JSON.stringify(res);
}

export default {
    install(Vue, option) {
        Vue.prototype.$Fetcher = new (function () {
            const DataValid = Vue.prototype.$validate.DataValid;
            const devLog = Vue.prototype.$common.log;
            const pad = Vue.prototype.$formatter.pad;
            const strtotime = Vue.prototype.$formatter.strtotime;

            /**
             * 
             * @param {String} upload_data - base64
             * @param {String} upload_file_type - e.g. jpg
             */
            this.UploadFile = async function (payload) {
                try {
                    const data = await Vue.prototype.$XHR.api('upload_file', payload);
                    if (typeof data === 'string') {
                        devLog('----------> XHR [SUCCESS]: UploadFile');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UploadFile');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UploadFile');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.Login = async function (username, password) {
                try {
                    const uploaded = {
                        username,
                        password
                    }
                    const data = await Vue.prototype.$XHR.api('staff_login', uploaded);
                    const formattedData = parseStaffData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: Login');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: Login');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: Login');
                    devLog(res);
                    switch (res.data) {
                        case 'login fail':
                            return Promise.reject('message.loginAccountInv');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.CustomerLogin = async function (username, password) {
                try {
                    const uploaded = {
                        username,
                        password
                    }
                    const data = await Vue.prototype.$XHR.api('student_login', uploaded);
                    const formattedData = parseCustomerData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: CustomerLogin');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: CustomerLogin');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CustomerLogin');
                    devLog(res);
                    switch (res.data) {
                        case 'login fail':
                            return Promise.reject('message.loginAccountInv');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            this.GetSetting = async function () {
                try {
                    const data = await Vue.prototype.$XHR.api('get_general_setting', {});
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetSetting');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetSetting');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ===== Required =====
             * @param {String} logo
             * @param {String} custom_text
             * ===== Optional =====
             * -- 基本設定
             * @param {String} phone
             * @param {String} email
             * @param {String} whatsapp_message
             * @param {String} member_terms_field
             * @param {String} agreement_sign_img
             * -- 付款設定
             * @param {Object<number: '', code: { file: '', name: '' }, link: ''>} payment_info_payme
             * @param {Object<number: '', code: { file: '', name: '' }, phone_email: ''>} payment_info_fps
             * @param {Object<number: '', code: { file: '', name: '' }>} payment_info_wechat_pay
             * @param {Object<number: '', code: { file: '', name: '' }>} payment_info_alipay
             * @param {Array<{bank_name: '', beneficiary_name: '', account_number: ''}>} payment_info_bank_transfer
             * @param {Array<string<'payme' | 'fps' | 'wechat_pay' | 'alipay' | 'bank_transfer' | 'cash'>>} accept_payment_methods
             */
            this.UpdateSetting = async function (update) {
                try {
                    let get_setting = await this.GetSetting();
                    for (const key in update) {
                        get_setting[key] = update[key];
                    }
                    const data = await Vue.prototype.$XHR.api('edit_general_setting', get_setting);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateSetting');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateSetting');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * Account/職員
             * ===== Required =====
             * @param {String} password_data
             * @param {String} username
             * 
             */
            this.NewAccount = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, STAFF_MODEL);
                    const uploaded = {
                        google_sync: false,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_staff', uploaded);
                    const formattedData = parseStaffData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewAccount');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewAccount');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewAccount');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                            return Promise.reject('message.accountExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateStaff = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, STAFF_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_staff', payload);
                    const formattedData = parseStaffData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateStaff');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateStaff');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateStaff');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetStaffs = async function (filters = {}) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_staff', filters);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseStaffData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStaffs');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetStaffs');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffs');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetStaffById = async function (id) {
                const payload = {
                    data_type: 'staff_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseStaffData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetStaffById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetStaffById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteStaff = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_staff', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteStaff');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteStaff');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.StaffChangePassword = async function (id, newPassword) {
                const payload = {
                    id: id,
                    password_data: newPassword
                }

                try {
                    await Vue.prototype.$XHR.api('edit_staff', payload);
                    devLog('----------> XHR [SUCCESS]: StaffChangePassword');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: StaffChangePassword');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetStaffsByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'staff_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data) && data.length > 0) {
                        const formattedData = data.map(parseStaffData);
                        devLog('----------> XHR [SUCCESS]: GetStaffsByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetStaffsByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffsByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }





            /**
             * 新增分店
             * ==== Required ====
             * @param {String} name 
             * @param {String} address
             */
            this.NewCenter = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, CENTER_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_center', uploaded);
                    const formattedData = parseCenterData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewCenter');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewCenter');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCenter');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateCenter = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, CENTER_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_center', payload);
                    const formattedData = parseCenterData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCenter');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateCenter');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCenter');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetCenters = async function (filters = {}) {
                const payload = {
                    data_type: 'center_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseCenterData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetCenters');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCenters');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCenters');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetCentersByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'center_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parseCenterData);
                        devLog('----------> XHR [SUCCESS]: GetCentersByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCentersByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCentersByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetCenterById = async function (id) {
                const payload = {
                    data_type: 'center_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseCenterData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCenterById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCenterById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCenterById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteCenter = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_center', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteCenter');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteCenter');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 客戶管理
             * ===== Optional =====
             * @param {number} filter_page - start from 0
             * @param {number} filter_limit
             * @param {number} center_id
             * @param {String} search - search keyword
             * @param {Array<{key: string, value: any}>} filter_item
             * filter_item key:
             * - 'name': string
             * - 'id': number
             * - 'phone': string
             * - 'grade': string
             * - 'school': string
             * - 'level': string
             * - 'create_date': string
             */
            this.GetCustomers = async function (filters = {}) {
                const payload = {
                    data_type: 'student_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseCustomerData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetCustomers');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCustomers');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCustomers');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            /**
             * 新增客戶
             * ===== Required =====
             * @param {String} password
             * @param {String} username
             * 
             */
            this.NewCustomer = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, CUSTOMER_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_student', uploaded);

                    const formattedData = parseCustomerData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewCustomer');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewCustomer');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCustomer');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                            return Promise.reject('message.accountExist');
                        case "phone exist":
                            return Promise.reject('message.phoneExist')
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateCustomer = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, CUSTOMER_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_student', payload);
                    const formattedData = parseCustomerData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCustomer');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateCustomer');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCustomer');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                            return Promise.reject('message.accountExist');
                        case "phone exist":
                            return Promise.reject('message.phoneExist')
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetCustomerById = async function (id, center_id = -1) {
                const payload = {
                    data_type: 'student_data',
                    id: id
                };

                if (center_id !== -1) {
                    payload.center_id = center_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseCustomerData(data);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCustomerById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCustomerById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCustomerById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ImportUser = async function (users = []) {
                let formattedUsers = JSON.parse(JSON.stringify(users));
                for (let i = 0; i < formattedUsers.length; i++) {
                    formattedUsers[i] = convertCMSKeyToBackendKey(formattedUsers[i], CUSTOMER_MODEL);
                }

                try {
                    const uploaded = {
                        students: formattedUsers
                    }
                    const data = await Vue.prototype.$XHR.api('import_student', uploaded);
                    const invStudents = [];
                    const importeds = [];

                    for (let i = 0; i < data.length; i++) {
                        if (typeof data[i] === 'string') {
                            invStudents.push(`${users[i].customer_name} (${users[i].username}): ${data[i].toUpperCase()}`);
                        } else if (typeof data[i] === 'object' && !data[i].id) {
                            invStudents.push(`${users[i].customer_name} (${users[i].username}): ERROR`);
                        } else {
                            const formattedData = parseCustomerData(data[i]);
                            if (formattedData) {
                                importeds.push(formattedData);
                            } else {
                                invStudents.push(`${users[i].customer_name} (${users[i].username}): ERROR`);
                            }
                        }
                    }

                    if (invStudents.length > 0) {
                        devLog(invStudents);
                        return Promise.resolve({ result: 'fail', data: invStudents });
                    } else {
                        devLog('----------> XHR [SUCCESS]: ImportUser');
                        devLog(importeds);
                        return Promise.resolve({ result: 'success', data: importeds });
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ImportUser');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.CustomerChangePassword = async function (id, newPassword) {
                const payload = {
                    id: id,
                    password_data: newPassword
                }

                try {
                    await Vue.prototype.$XHR.api('edit_student', payload);
                    devLog('----------> XHR [SUCCESS]: CustomerChangePassword');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: CustomerChangePassword');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            const GetCustomersByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'student_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data) && data.length > 0) {
                        const formattedData = data.map(parseCustomerData);
                        devLog('----------> XHR [SUCCESS]: GetCustomersByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetCustomersByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCustomersByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }





            /**
             * 新增課室
             * ==== Required ====
             * @param {String} name 
             * @param {Number} center - center id
             */
            this.NewRoom = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ROOM_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_facility', uploaded);
                    const formattedData = parseRoomData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewRoom');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewRoom');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewRoom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateRoom = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, ROOM_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_facility', payload);
                    const formattedData = parseRoomData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateRoom');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateRoom');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateRoom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetRooms = async function (filters = {}) {
                let joinCenterData = false;
                if (filters['join_center_data'] === true) {
                    joinCenterData = true;
                    delete filters['join_center_data'];
                }

                const payload = {
                    data_type: 'facility_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let schoolData = [];

                        if (joinCenterData === true) {
                            const idList = data['data'].map(el => el.center_id);
                            if (idList.length > 0) {
                                schoolData = await GetCentersByIdList(idList);
                            }
                        }

                        const formattedData = data['data'].map(el => parseRoomData(el, schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetRooms');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetRooms');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetRooms');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            this.GetRoomById = async function (id) {
                const payload = {
                    data_type: 'facility_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseRoomData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetRoomById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetRoomById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetRoomById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteRoom = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_facility', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteRoom');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteRoom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增升級服務分類
             * ==== Required ====
             * @param {String} name 
             * @param {String} category_code
             */
            this.NewServiceCategory = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, SERVICE_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_course_category', uploaded);
                    const formattedData = parseServiceCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewServiceCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewServiceCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewServiceCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.UpdateServiceCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, SERVICE_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_course_category', payload);
                    const formattedData = parseServiceCategoryData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateServiceCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateServiceCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateServiceCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetServiceCategories = async function (filters = {}) {
                const payload = {
                    data_type: 'course_category_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseServiceCategoryData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetServiceCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServiceCategories');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServiceCategories');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetServiceCategoriesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'course_category_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parseServiceCategoryData);
                        devLog('----------> XHR [SUCCESS]: GetServiceCategoriesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServiceCategoriesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServiceCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetServiceCategoryById = async function (id) {
                const payload = {
                    data_type: 'course_category_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseServiceCategoryData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetServiceCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServiceCategoryById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServiceCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteServiceCategory = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_course_category', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteServiceCategory');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteServiceCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
             * 新增服務分類
             * ==== Required ====
             * @param {String} name 
             * @param {String} category_code
             */
            this.NewGeneralServiceCategory = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, SERVICE_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_service_category', uploaded);
                    const formattedData = parseServiceCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewGeneralServiceCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewGeneralServiceCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewGeneralServiceCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateGeneralServiceCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, SERVICE_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_service_category', payload);
                    const formattedData = parseServiceCategoryData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateGeneralServiceCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateGeneralServiceCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateGeneralServiceCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetGeneralServiceCategories = async function (filters = {}) {
                const payload = {
                    data_type: 'service_category_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseServiceCategoryData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetGeneralServiceCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetGeneralServiceCategories');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetGeneralServiceCategories');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetGeneralServiceCategoriesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'service_category_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parseServiceCategoryData);
                        devLog('----------> XHR [SUCCESS]: GetGeneralServiceCategoriesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetGeneralServiceCategoriesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServiceCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetGeneralServiceCategoryById = async function (id) {
                const payload = {
                    data_type: 'service_category_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseServiceCategoryData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetGeneralServiceCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetGeneralServiceCategoryById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetGeneralServiceCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteGeneralServiceCategory = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_service_category', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteGeneralServiceCategory');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteGeneralServiceCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
             * 新增服務
             * ==== Optional ====
             * @param {String} name 
             * @param {String} code - course_code 
             * @param {int} category_id - course_category_id 
             * @param {int} duration
             * @param {float} credit
             * @param {float} dollar
             */
            this.NewService = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, SERVICE_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_course', uploaded);
                    const formattedData = parseServiceData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewService');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewService');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewService');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateService = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, SERVICE_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_course', payload);
                    const formattedData = parseServiceData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateService');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateService');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateService');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetServices = async function (filters = {}) {
                let joinCategoryData = false;
                let joinGeneralServiceCategoryData = false;
                if (filters['join_category_data'] === true) {
                    joinCategoryData = true;
                    delete filters['join_category_data'];
                }
                if (filters['join_general_service_category_data'] === true) {
                    joinGeneralServiceCategoryData = true;
                    delete filters['join_general_service_category_data'];
                }

                const payload = {
                    data_type: 'course_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let categoryData = [];
                        let generalServiceCategoryData = [];
                        if (joinCategoryData === true) {
                            const idList = data['data'].map(el => el.course_category_id);
                            if (idList.length > 0) {
                                categoryData = await GetServiceCategoriesByIdList(idList);
                            }
                        }
                        if (joinGeneralServiceCategoryData === true) {
                            let idList = [];
                            data['data'].forEach(service => {
                                if (DataValid(service.service_category_id_list)) {
                                    idList = idList.concat(service.service_category_id_list)
                                }
                            });

                            if (idList.length > 0) {
                                generalServiceCategoryData = await GetGeneralServiceCategoriesByIdList(idList)
                            }
                        }

                        const formattedData = data['data'].map(el => parseServiceData(el, categoryData, generalServiceCategoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetServices');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServices');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServices');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetServiceById = async function (id) {
                const payload = {
                    data_type: 'course_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseServiceData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetServiceById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServiceById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServiceById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteService = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_course', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteService');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteService');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            const GetServicesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'course_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(el => parseServiceData(el));
                        devLog('----------> XHR [SUCCESS]: GetServicesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetServicesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServicesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }





            /**
             * 新增商品分類
             * ==== Required ====
             * @param {String} name 
             */
            this.NewProductCategory = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PRODUCT_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_category', uploaded);
                    const formattedData = parseProductCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewProductCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewProductCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateProductCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PRODUCT_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_category', payload);
                    const formattedData = parseProductCategoryData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateProductCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateProductCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetProductCategories = async function (filters = {}) {
                const payload = {
                    data_type: 'category_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseProductCategoryData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetProductCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductCategories');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategories');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetProductCategoriesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'category_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parseProductCategoryData);
                        devLog('----------> XHR [SUCCESS]: GetProductCategoriesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductCategoriesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetProductCategoryById = async function (id) {
                const payload = {
                    data_type: 'category_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseProductCategoryData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetProductCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductCategoryById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteProductCategory = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_category', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteProductCategory');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增商品
             * ==== Required ====
             * @param {String} name 
             */
            this.NewProduct = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PRODUCT_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_product', uploaded);
                    const formattedData = parseProductData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewProduct');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewProduct');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateProduct = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PRODUCT_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_product', payload);
                    const formattedData = parseProductData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateProduct');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateProduct');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ===== Optional =====
             * @param {number} filter_page - start from 0
             * @param {number} filter_limit
             * @param {number} center_id
             * @param {Array<{key: string, value: any}>} filter_item
             * filter_item key:
             * - 'name': string
             */
            this.GetProducts = async function (filters = {}) {
                let joinCategoryData = false;

                if (filters['join_category_data'] === true) {
                    joinCategoryData = true;
                    delete filters['join_category_data'];
                }

                const payload = {
                    data_type: 'product_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let categoryData = [];
                        if (joinCategoryData === true) {
                            const idList = data['data'].map(el => el.category);
                            if (idList.length > 0) {
                                categoryData = await GetProductCategoriesByIdList(idList);
                            }
                        }

                        const formattedData = data['data'].map(el => {
                            if (el.inventories) {
                                el[PRODUCT_MODEL.inventory] = el.inventories;
                            } else {
                                el[PRODUCT_MODEL.inventory] = 0;
                            }
                            return parseProductData(el, categoryData);
                        });
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetProducts');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProducts');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProducts');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetProductById = async function (id) {
                const payload = {
                    data_type: 'product_data',
                    id: id
                };

                try {
                    let data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    // -- get inventory
                    const inventory = await this.GetProductInventory(id);
                    data[PRODUCT_MODEL.inventory] = inventory;
                    const formattedData = parseProductData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetProductById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteProduct = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_product', { id });

                    devLog('----------> XHR [SUCCESS]: DeleteProduct');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetProductSale = async function (id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_product_sales', { product_id: id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetProductSale');
                        let count = 0;
                        data.forEach(order => {
                            const found = order.product_id_list.find(el => el.id === id);
                            if (found) {
                                count += found.amount
                                if (order.status === 'debit') {
                                    const refund = order.debit_product_ids.find(el => el.id === id);
                                    if (refund) {
                                        count -= refund.amount;
                                    }
                                } else if (order.status === 'void') {
                                    count -= found.amount;
                                }
                            }
                        })
                        return Promise.resolve(count);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductSale');
                        return Promise.resolve(0);
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductSale');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            /**
             * ----------------- 商品出入倉紀錄 -----------------
             */
            /**
             * 商品出入倉
             * ==== Required ====
             * @param {int} staff_id
             * @param {int} amount
             * @param {string} date
             */
            this.AddProductInventory = async function (product_id, update) {
                const payload = {
                    id: product_id,
                    ...update
                }
                if (payload['amount'] < 0) {
                    payload['amount'] = Math.abs(payload['amount']);
                }
                try {
                    const data = await Vue.prototype.$XHR.api('update_product_inventory', payload);
                    const formattedData = parseProductInventoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: AddProductInventory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: AddProductInventory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddProductInventory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ReduceProductInventory = async function (product_id, update) {
                const payload = {
                    id: product_id,
                    ...update
                }
                if (payload['amount'] > 0) {
                    payload['amount'] = payload['amount'] * -1;
                }
                try {
                    const data = await Vue.prototype.$XHR.api('update_product_inventory', payload);
                    const formattedData = parseProductInventoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: ReduceProductInventory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: ReduceProductInventory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: ReduceProductInventory');
                    devLog(res);
                    switch (res.data) {
                        case 'inventory not enough':
                            return Promise.reject('message.stockNotEnough');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetProductInventory = async function (product_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_product_remain', {
                        id: product_id
                    });
                    devLog('----------> XHR [SUCCESS]: GetProductInventory');
                    devLog(data)
                    return Promise.resolve(data || 0);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductInventory');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetProductInventoryRecords = async function (filters = {}) {
                let joinStaffData = false;
                if (filters['join_staff_data'] === true) {
                    joinStaffData = true;
                    delete filters['join_staff_data'];
                }

                const payload = {
                    data_type: 'product_inventory_record_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let staffData = [];
                        if (joinStaffData === true) {
                            const idList = data['data'].map(el => el[PRODUCT_INVENTORY_MODEL.staff_id]);
                            if (idList.length > 0) {
                                staffData = await this.GetStaffsByIdList(idList);
                            }
                        }

                        const orderIds = [];
                        const orderGroupIds = [];
                        let orderData = [];
                        data['data'].forEach(el => {
                            if (el.order_id > -1 && !orderIds.includes(el.order_id)) {
                                if (el[PRODUCT_INVENTORY_MODEL.resource] === 'order debit') {
                                    if (!orderGroupIds.includes(el.order_id)) {
                                        orderGroupIds.push(el.order_id);
                                    }
                                } else if (!orderIds.includes(el.order_id)) {
                                    orderIds.push(el.order_id);
                                }
                            }
                        })
                        if (orderGroupIds.length) {
                            orderData = await GetOrderGroupsByIdList(orderGroupIds, { join_code: true })
                        }
                        if (orderIds.length) {
                            const orderGroups = await _GetOrderGroupsByOrderIds(orderIds);
                            orderData = orderData.concat(orderGroups);
                        }

                        const formattedData = data['data'].map(el => parseProductInventoryData(el, staffData, orderData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetProductInventoryRecords');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetProductInventoryRecords');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductInventoryRecords');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const _GetOrderGroupsByOrderIds = async function (orderIds, count = 0, list = []) {
                if (count < orderIds.length) {
                    try {
                        const data = await GetOrderGroupByOrderId(orderIds[count], true);
                        list.push(data);
                    } catch { } finally {
                        count += 1;
                        return await _GetOrderGroupsByOrderIds(orderIds, count, list);
                    }
                } else {
                    return list;
                }
            }






            /**
             * 繳費
             */
            this.GetPayTuitions = async function (filters = {}) {
                const payload = {
                    data_type: 'student_data',
                    ...filters
                };

                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parsePayTuitionData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPayTuitions');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPayTuitions');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPayTuitions');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetPayTuitionById = async function (id, center_id = -1) {
                const payload = {
                    data_type: 'student_data',
                    id: id
                };
                if (center_id !== -1) {
                    payload.center_id = center_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parsePayTuitionData(data);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPayTuitionById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPayTuitionById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPayTuitionById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 套票分類設定
             * ==== Required ====
             * @param {String} name - category_name
             * @param {String} code - package_category_code
             */
            this.NewPackageCategory = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PACKAGE_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_package_category', uploaded);
                    const formattedData = parsePackageCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewPackageCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewPackageCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewPackageCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdatePackageCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PACKAGE_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_package_category', payload);
                    const formattedData = parsePackageCategoryData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdatePackageCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdatePackageCategory');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdatePackageCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.categoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetPackageCategories = async function (filters = {}) {
                const payload = {
                    data_type: 'package_category_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parsePackageCategoryData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPackageCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackageCategories');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageCategories');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetPackageCategoriesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'package_category_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parsePackageCategoryData);
                        devLog('----------> XHR [SUCCESS]: GetPackageCategoriesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackageCategoriesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetPackageCategoryById = async function (id) {
                const payload = {
                    data_type: 'package_category_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parsePackageCategoryData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPackageCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackageCategoryById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeletePackageCategory = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_package_category', { id });

                    devLog('----------> XHR [SUCCESS]: DeletePackageCategory');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeletePackageCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 套票
             * ======== Required ========
             * @param {string} name - package_name
             * @param {float} price
             * @param {Array<number>} centers - center
             * @param {string} type - "month" | "credit" | "dollar" | "normal"
             * @param {int} days
             * @param {int} category_id
             * ======== Optional ========
             * @param {string} code - package_code
             * // for type = "month"
             * @param {Array<
             *  service_count: 0, 
             *  service_list: Array<number>, 
             *  service_detail_list: Array<{course_category_id: -1, course_id: -1, quota: 0}>, 
             *  upgrade_service_list: Array<{course_category_id: -1, course_id: -1, quota: 0}>
             * >} set
             * // for type = "dollar"
             * @param {int} add_dollar
             * // for type = "credit"
             * @param {int} add_credit
             */
            this.NewPackage = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PACKAGE_MODEL);
                    const uploaded = {
                        ...formattedPayload,
                        count: 0
                    }

                    const data = await Vue.prototype.$XHR.api('new_package', uploaded);
                    const formattedData = parsePackageData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewPackage');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewPackage');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewPackage');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdatePackage = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PACKAGE_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_package', payload);
                    const formattedData = parsePackageData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdatePackage');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdatePackage');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdatePackage');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeletePackage = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_package', { id });

                    devLog('----------> XHR [SUCCESS]: DeletePackage');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeletePackage');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetPackages = async function (filters = {}) {
                let joinServiceCategory = false;
                let joinCategory = false;

                if (filters['join_service_category_data'] !== undefined) {
                    if (filters['join_service_category_data'] === true) {
                        joinServiceCategory = true;
                    }
                    delete filters['join_service_category_data'];
                }

                if (filters['join_category_data'] !== undefined) {
                    if (filters['join_category_data'] === true) {
                        joinCategory = true;
                    }
                    delete filters['join_category_data'];
                }

                const payload = {
                    data_type: 'package_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let service_category_datas = [];
                        if (joinServiceCategory) {
                            const category_ids = [];
                            data['data'].forEach(item => {
                                if (DataValid(item[PACKAGE_MODEL.set]) && item[PACKAGE_MODEL.set].length > 0) {
                                    item[PACKAGE_MODEL.set].forEach(set => {
                                        set.service_detail_list.forEach(service => {
                                            if (service.course_category_id !== -1 && !category_ids.includes(service.course_category_id)) {
                                                category_ids.push(service.course_category_id);
                                            }
                                        })
                                        set.upgrade_service_list.forEach(service => {
                                            if (service.course_category_id !== -1 && !category_ids.includes(service.course_category_id)) {
                                                category_ids.push(service.course_category_id);
                                            }
                                        })
                                    })
                                }
                            })

                            if (category_ids.length) {
                                service_category_datas = await GetServiceCategoriesByIdList(category_ids);
                            }
                        }

                        let category_datas = [];
                        if (joinCategory) {
                            const category_ids = data['data'].map(el => el[PACKAGE_MODEL.category_id]);
                            if (category_ids.length) {
                                category_datas = await GetPackageCategoriesByIdList(category_ids);
                            }
                        }

                        const formattedData = data['data'].map(el => parsePackageData(el, category_datas, service_category_datas));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPackages');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackages');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackages');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            this.GetPackageById = async function (id) {
                const payload = {
                    data_type: 'package_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parsePackageData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPackageById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackageById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetPackagesByIdList = async function (id_list, filters = {}) {
                const payload = {
                    data_type: 'package_data',
                    id_list: id_list,
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        const formattedData = data.map(parsePackageData);
                        devLog('----------> XHR [SUCCESS]: GetPackagesByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetPackagesByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackagesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }





            /**
             * 新增預約
             * ======== Required ========
             * @param {number} user_id - student_id
             * @param {Array<{course_id: -1, course_category_id: -1}>} selected
             * @param {string} use_type - 'package' | 'credit' | 'dollar'
             * @param {string} date
             * @param {string} start_time
             * @param {string} end_time
             * ======== Optional ========
             * @param {Array<{course_id: -1, staff_id: -1}>} staff_list - course_staff
             * @param {number} room_id - facility_id
             * @param {string} color
             * @param {string} code - course_code
             * @param {number} center_id
             * // use_type 係month，又未用過package
             * @param {object} selected_package_type - set object
             * @param {number} order_id - 月票/格仔/value用指定package
             * @param {number} package_id - 格仔/value用指定package
             */
            this.NewBooking = async function (payload) {
                try {
                    let formattedPayload = convertCMSKeyToBackendKey(payload, BOOKING_MODEL);
                    formattedPayload['student_id'] = formattedPayload['user_id'];
                    delete formattedPayload['user_id'];

                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('assign_service', uploaded);
                    if (data) {
                        devLog('----------> XHR [SUCCESS]: NewBooking');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewBooking');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewBooking');
                    devLog(res);
                    switch (res.data) {
                        case 'credit not enough':
                            return Promise.reject('message.creditNotEnough');
                        case 'dollar not enough':
                            return Promise.reject('message.dollarNotEnough');
                        case 'package quota not enough':
                            return Promise.reject('message.quotaNotEnough');
                        case 'package category quota not enough':
                            return Promise.reject('message.upgradeNotEnough');
                        case 'service unavailable':
                            return Promise.reject(res)
                        case 'some invalid shift exists':
                            return Promise.reject('message.staffWithoutShift')
                        default:
                            return Promise.reject(displayError(res));
                    }

                }
            }
            /**
             * CANNOT edit use_type
             * if use_type = "credit" / "dollar", 可以加減 service_id_list
             * if use_type = "package", 可以唔洗揀服務住，遲下再揀返
             */
            this.UpdateBooking = async function (id, update) {
                try {
                    let formattedPayload = convertCMSKeyToBackendKey(update, BOOKING_MODEL);
                    if (formattedPayload['user_id'] !== undefined) {
                        delete formattedPayload['user_id'];
                    }
                    if (formattedPayload['selected'] !== undefined) {
                        formattedPayload[BOOKING_MODEL.service_id_list] = formattedPayload['selected'].map(el => el.course_id);
                        formattedPayload['courses'] = formattedPayload['selected'];
                        delete formattedPayload['selected'];
                    }
                    if (formattedPayload[BOOKING_MODEL.use_type] !== undefined) {
                        // if (formattedPayload[BOOKING_MODEL.service_id_list] !== undefined && formattedPayload[BOOKING_MODEL.use_type] !== 'credit' && formattedPayload[BOOKING_MODEL.use_type] !== 'dollar') {
                        //     delete formattedPayload[BOOKING_MODEL.service_id_list];
                        // }
                        delete formattedPayload[BOOKING_MODEL.use_type];
                    }

                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_lesson', payload);
                    const formattedData = parsePackageData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateBooking');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateBooking');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBooking');
                    devLog(res);
                    switch (res.data) {
                        case 'credit not enough':
                            return Promise.reject('message.creditNotEnough');
                        case 'dollar not enough':
                            return Promise.reject('message.dollarNotEnough');
                        case 'package quota not enough':
                            return Promise.reject('message.quotaNotEnough');
                        case 'package category quota not enough':
                            return Promise.reject('message.upgradeNotEnough');
                        case 'service unavailable':
                            return Promise.reject(res)
                        case 'some invalid shift exists':
                            return Promise.reject('message.staffWithoutShift')
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.CancelBooking = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('cancel_lesson', { id });
                    devLog('----------> XHR [SUCCESS]: CancelBooking');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CancelBooking');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetUserBookings = async function (user_id, filter = {}) {
                const payload = {
                    student_id: user_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_student_lesson', payload);
                    if (DataValid(data) && data.length > 0) {
                        const actives = data.filter(el => el.active);
                        if (actives.length > 0) {
                            const service_ids = [];
                            actives.forEach(item => {
                                item[BOOKING_MODEL.service_id_list]?.forEach(sid => {
                                    const found = service_ids.find(el => el === sid);
                                    if (!found) {
                                        service_ids.push(sid);
                                    }
                                })
                            })
                            const get_services = await GetServicesByIdList(service_ids);
                            const formattedData = actives.map(el => parseBookingData(el, get_services));
                            formattedData.sort((a, b) => {
                                const aDate = strtotime(`${a.date}T${a.start_time}:00Z`);
                                const bDate = strtotime(`${b.date}T${b.start_time}:00Z`);
                                return bDate - aDate;
                            })


                            let returnData = [];
                            if (filter['filter_page'] !== undefined && filter['filter_limit'] !== undefined) {
                                const startIndex = filter['filter_page'] * filter['filter_limit'];
                                const endIndex = startIndex + filter['filter_limit'];
                                for (let i = startIndex; i < endIndex; i++) {
                                    if (formattedData[i]) {
                                        returnData.push(formattedData[i]);
                                    } else {
                                        break;
                                    }
                                }
                            } else {
                                returnData = formattedData;
                            }

                            if (returnData.length) {
                                devLog('----------> XHR [SUCCESS]: GetUserBookings');
                                devLog(formattedData)
                                return Promise.resolve({
                                    total: formattedData.length,
                                    data: returnData
                                });
                            }
                        }
                    }

                    devLog('----------> XHR [NULL]: GetUserBookings');
                    return Promise.reject([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserBookings');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            /**
             * ===== Optional =====
             * @param {number} filter_page - start from 0
             * @param {number} filter_limit
             * @param {number} center_id
             * @param {Array<{key: string, value: any}>} filter_item
             * filter_item key:
             * - 'date': string
             * - 'start_date': string
             * - 'end_date': string
             * - 'staff_id': number
             * - 'course_id': number
             * - 'course_id_list': Array<number>
             * - 'student_id': number
             * - 'course_code': string
             * - 'weekdays': Array<number>
             */
            this.GetBookings = async function (filters = {}) {
                let joinStaffData = false;
                if (filters['join_staff_data'] === true) {
                    joinStaffData = true;
                    delete filters['join_staff_data'];
                }

                let joinUserData = false;
                if (filters['join_user_data'] === true) {
                    joinUserData = true;
                    delete filters['join_user_data'];
                }

                let joinServiceData = false;
                if (filters['join_service_data'] === true) {
                    joinServiceData = true;
                    delete filters['join_service_data'];
                }

                const payload = {
                    data_type: 'lesson_data',
                    order_by: 'date',
                    sort_dir: 'asc',
                    ...filters
                };

                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let staffData = [];
                        if (joinStaffData === true) {
                            let idList = [];

                            data['data'].forEach(el => {
                                if (DataValid(el[BOOKING_MODEL.staff_list])) {
                                    el[BOOKING_MODEL.staff_list] = [...new Set(el[BOOKING_MODEL.staff_list])]

                                    if (el[BOOKING_MODEL.staff_list].length > 0) {
                                        el[BOOKING_MODEL.staff_list].forEach(staff => {
                                            idList.push(staff.staff_id);
                                        })
                                    }
                                } else if (DataValid(el[BOOKING_MODEL.staff_id]) && el[BOOKING_MODEL.staff_id] > -1) {
                                    idList.push(el[BOOKING_MODEL.staff_id]);
                                }
                            });

                            idList = [...new Set(idList)]
                            if (idList.length > 0) {
                                staffData = await this.GetStaffsByIdList(idList);
                            }
                        }

                        let userData = [];
                        if (joinUserData === true) {
                            const idList = [];
                            data['data'].forEach(el => {
                                if (DataValid(el[BOOKING_MODEL.user_id_list])) {
                                    el[BOOKING_MODEL.user_id_list].forEach(id => {
                                        idList.push(id);
                                    })
                                }
                            })

                            if (idList.length > 0) {
                                userData = await GetCustomersByIdList(idList);
                            }
                        }

                        let serviceData = [];
                        if (joinServiceData === true) {
                            const idList = [];
                            data['data'].forEach(item => {
                                item[BOOKING_MODEL.service_id_list]?.forEach(sid => {
                                    const found = idList.find(el => el === sid);
                                    if (!found) {
                                        idList.push(sid);
                                    }
                                })
                            })
                            if (idList.length > 0) {
                                serviceData = await GetServicesByIdList(idList);
                            }
                        }

                        const formattedData = data['data'].map(el => parseBookingData(el, serviceData, userData, staffData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetBookings');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetBookings');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBookings');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetBookingById = async function (id, center_id = -1) {
                const payload = {
                    data_type: 'lesson_data',
                    id: id
                };

                if (center_id !== -1) {
                    payload.center_id = center_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseBookingData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetBookingById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetBookingById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBookingById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateBookingAttendance = async function (booking_id, attendance) {
                try {
                    const payload = {
                        id: booking_id,
                        attendance
                    }

                    const data = await Vue.prototype.$XHR.api('edit_lesson', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateBookingAttendance');
                        devLog(data)
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateBookingAttendance');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBookingAttendance');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetUserCreditCanUse = async function (user_id) {
                const payload = {
                    student_id: user_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_user_credit', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserCreditCanUse');
                        devLog(data)
                        const canUse = (data.total || 0) - (data.used || 0) - (data.hold || 0) - (data.deduct || 0);
                        return Promise.resolve(canUse);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserCreditCanUse');
                        devLog(data);
                        return Promise.resolve(0);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserCreditCanUse');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetUserCreditUsedInMonth = async function (user_id) {
                let payload = {
                    student_id: user_id
                };

                const today = serverTimeFunc.getLocalCurrentDateObj();
                payload['month'] = `${today.getFullYear()}-${pad(today.getMonth() + 1)}`;

                try {
                    const data = await Vue.prototype.$XHR.api('get_user_credit_spend', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserCreditUsedInMonth');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserCreditUsedInMonth');
                        devLog(data);
                        return Promise.resolve(0);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserCreditUsedInMonth');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetUserDollarCanUse = async function (user_id) {
                const payload = {
                    student_id: user_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_user_dollar', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserDollarCanUse');
                        devLog(data)
                        const canUse = (data.total || 0) - (data.used || 0) - (data.hold || 0) - (data.deduct || 0);
                        return Promise.resolve(canUse);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserDollarCanUse');
                        devLog(data);
                        return Promise.resolve(0);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserDollarCanUse');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetUserDollarUsedInMonth = async function (user_id) {
                let payload = {
                    student_id: user_id
                };
                const today = serverTimeFunc.getLocalCurrentDateObj();
                payload['month'] = `${today.getFullYear()}-${pad(today.getMonth() + 1)}`;

                try {
                    const data = await Vue.prototype.$XHR.api('get_user_dollar_spend', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserDollarUsedInMonth');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserDollarUsedInMonth');
                        devLog(data);
                        return Promise.resolve(0);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserDollarUsedInMonth');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetPurchasedCreditList = async function (user_id, lesson_id = -1) {
                const payload = {
                    student_id: user_id
                };

                if (lesson_id !== -1) {
                    payload.lesson_id = lesson_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_purchased_credit_list', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPurchasedCreditList');
                        devLog(data)

                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPurchasedCreditList');
                        devLog(data);
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPurchasedCreditList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }

            this.GetPurchasedDollarList = async function (user_id, lesson_id = -1) {
                const payload = {
                    student_id: user_id
                };

                if (lesson_id !== -1) {
                    payload.lesson_id = lesson_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_purchased_dollar_list', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPurchasedDollarList');
                        devLog(data)

                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPurchasedDollarList');
                        devLog(data);
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPurchasedDollarList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }

            const _parseMonthPackageOrder = async function (orders, now, get_future = false, get_category = false, booking_id = -1) {
                const filterMonthPackageOrders = orders.filter(el => {
                    if ((el.status === 'paid' || el.status === 'partially_paid' || booking_id > -1) && DataValid(el.package_data) && el.package_data.type === 'month') {
                        let start_date = null;
                        let end_date = null;
                        if (el.start_date) start_date = strtotime(el.start_date);
                        if (el.end_date) end_date = strtotime(el.end_date);

                        if (!start_date && !end_date) {
                            if (DataValid(el.expiry) && el.expiry.length > 0) {
                                let in_period = false;
                                for (let i = 0; i < el.expiry.length; i++) {
                                    const _start = strtotime(el.expiry[i].start_date);
                                    const _end = strtotime(el.expiry[i].end_date);
                                    if ((_start <= now && now <= _end) || (get_future === true && _start >= now)) {
                                        in_period = true;
                                        break;
                                    }
                                }

                                return in_period;
                            } else {
                                return true;
                            }
                        }

                        return (start_date <= now && now <= end_date) || (get_future === true && start_date >= now);
                    }

                    return false;
                });

                const uniquePackageOrders = [];
                filterMonthPackageOrders.forEach(order => {
                    const exist = uniquePackageOrders.find(el => el.id === order.id);
                    if (!exist) uniquePackageOrders.push(order);
                })
                uniquePackageOrders.sort((a, b) => strtotime(a.create_date) - strtotime(b.create_date));

                const list = uniquePackageOrders.map(el => {
                    let used = false;
                    let is_last_month = false
                    let combine_chosen = false;
                    let original_end = el.end_date
                    let original_days = el.package_data.days;
                    let expiryIndex = -1;

                    if (el.start_date && DataValid(el.expiry) && el.expiry.length > 0 && DataValid(el.quota) && el.quota.length > 0) {
                        used = true;
                        for (let i = 0; i < el.expiry.length; i++) {
                            const _start = strtotime(el.expiry[i].start_date);
                            const _end = strtotime(el.expiry[i].end_date);
                            if (_start <= now && now <= _end) {
                                expiryIndex = i;
                                if (i + 1 == el.expiry.length) {
                                    is_last_month = true;
                                }
                                if (DataValid(el.quota[i])) {
                                    combine_chosen = true
                                }
                                break;
                            }
                        }


                        let start = el.start_date
                        const startDateObj = Vue.prototype.$formatter.getDateObj(start)

                        if (DataValid(el.package_data.original_days)) {
                            original_days = el.package_data.original_days;
                            original_end = new Date(startDateObj.setDate(startDateObj.getDate() + original_days - 1));
                            original_end = `${Vue.prototype.$formatter.formatDate(original_end)}T23:59:59Z`
                        } else if (DataValid(el.payment_package_data)) {
                            if (el.payment_package_data.days !== el.package_data.days) {
                                original_days = el.payment_package_data.days;
                                original_end = new Date(startDateObj.setDate(startDateObj.getDate() + original_days - 1));
                                original_end = `${Vue.prototype.$formatter.formatDate(original_end)}T23:59:59Z`
                            }
                        }


                    }
                    return {
                        id: el.id, // order_data id
                        create_date: el.create_date,
                        name: el.package_name,
                        start_date: el.start_date,
                        end_date: el.end_date,
                        original_end_date: original_end,
                        package_data: el.package_data,
                        days: el.package_data.days,
                        original_days: original_days,
                        is_last_month: is_last_month,
                        center_id: el.center_id,
                        price: el.package_price,
                        package_id: el.package_data.id,
                        package_set: el.package_data[PACKAGE_MODEL.set] || [],
                        quota: el.quota,
                        expiry: el.expiry,
                        used: used,
                        expiry_index: expiryIndex,
                        combine_chosen: combine_chosen,
                        package_category_id: el.package_data.package_category_id,
                        active: !!(el.status === 'paid' || el.status === 'partially_paid')
                    }
                })

                if (list.length) {
                    const category_ids = [];
                    list.forEach(item => {
                        const quota_set = []; // 如果個個月揀咗package，正常得一set，otherwise，跟返package有幾多set

                        /**
                         * Case 1: 未有start/end date，未有expiry length/冇quota -> new quota set
                         * Case 2: 有start/end date，in expiry，有quota -> quota
                         * Case 3: 有start/end date，in expiry，冇quota (有可能取消咗booking/extended)
                         */

                        let genNewQuotaSet = false;

                        if ((!DataValid(item.expiry) || item.expiry.length < 1) && (!DataValid(item.quota) || item.quota.length < 1)) { // case 1
                            genNewQuotaSet = true;
                        } else {
                            for (let i = 0; i < item.expiry.length; i++) {
                                const start_date = strtotime(item.expiry[i].start_date);
                                const end_date = strtotime(item.expiry[i].end_date);
                                if ((start_date <= now && now <= end_date) || (get_future === true && start_date >= now)) {
                                    if (DataValid(item.quota[i])) { // Case 2
                                        const obj = {
                                            service_detail_list: [],
                                            upgrade_service_list: JSON.parse(JSON.stringify(item.quota[i].upgrade_service_list)),
                                            treatment_quota_per_month: 0,
                                            start_date: item.expiry[i].start_date,
                                            end_date: item.expiry[i].end_date,
                                        };
                                        item.quota[i].service_detail_list[0].forEach(treatment => {
                                            obj['service_detail_list'].push({
                                                course_category_id: treatment.course_category_id,
                                                course_id: treatment.course_id,
                                                quota: treatment.quota,
                                            })
                                        })

                                        item.quota[i].service_detail_list.forEach(treatment => {
                                            let unusedCount = 0;
                                            treatment.forEach(service => {
                                                if (Vue.prototype.$validate.isQuotaUnused(service)) {
                                                    unusedCount += 1;
                                                } else if (service.lesson === booking_id) {
                                                    // 如果係更改預約，release返個quota出黎
                                                    unusedCount += 1;
                                                }

                                                if (service.course_category_id !== -1) {
                                                    category_ids.push(service.course_category_id);
                                                }
                                            })
                                            if (unusedCount === treatment.length) obj['treatment_quota_per_month'] += 1;
                                        })

                                        obj.upgrade_service_list.forEach(service => {
                                            service['quota_per_month'] = service.quota;
                                            if (service.used_count) {
                                                service['quota_per_month'] = service.quota - service.used_count;
                                            }

                                            // 如果係更改預約，release返個quota出黎
                                            if (DataValid(service.lessons) && service.lessons.includes(booking_id)) {
                                                for (let j = 0; j < service.lessons.length; j++) {
                                                    if (service.lessons[j] === booking_id) {
                                                        service['quota_per_month'] += 1;
                                                    }
                                                }
                                            }

                                            if (service.course_category_id !== -1) {
                                                category_ids.push(service.course_category_id);
                                            }
                                        })
                                        quota_set.push(obj);
                                    } else {  // Case 3
                                        genNewQuotaSet = true;
                                    }
                                    break;
                                }
                            }
                        }

                        if (genNewQuotaSet === true && DataValid(item.package_set) && item.package_set.length > 0) {
                            item.package_set.forEach(set => {
                                const obj = {
                                    service_detail_list: JSON.parse(JSON.stringify(set.service_detail_list)),
                                    upgrade_service_list: JSON.parse(JSON.stringify(set.upgrade_service_list)),
                                    treatment_quota_per_month: set.service_count,
                                    start_date: '',
                                    end_date: '',
                                };

                                obj.upgrade_service_list.forEach(service => {
                                    if (service.course_category_id !== -1) {
                                        category_ids.push(service.course_category_id);
                                    }

                                    service['quota_per_month'] = service.quota;
                                })

                                // case 3
                                if (item.start_date && item.end_date) {
                                    obj['start_date'] = item.start_date;
                                    obj['end_date'] = item.end_date;
                                    if (DataValid(item.expiry) && item.expiry.length > 0) {
                                        for (let i = 0; i < item.expiry.length; i++) {
                                            const _start = strtotime(item.expiry[i].start_date);
                                            const _end = strtotime(item.expiry[i].end_date);
                                            if ((_start <= now && now <= _end) || (get_future === true && _start >= now)) {
                                                obj['start_date'] = item.expiry[i].start_date;
                                                obj['end_date'] = item.expiry[i].end_date;
                                                break;
                                            }
                                        }
                                    }
                                }

                                quota_set.push(obj);
                            })
                        }

                        item['quota_set'] = quota_set;
                    })

                    if (get_category === true && category_ids.length > 0) {
                        const category_data = await GetServiceCategoriesByIdList(category_ids);
                        list.forEach(item => {
                            item.quota_set.forEach(set => {
                                set.service_detail_list.forEach(service => {
                                    if (service.course_category_id !== -1) {
                                        const found = category_data.find(el => el.id === service.course_category_id);
                                        service.category_name = found?.name || '';
                                    }
                                })

                                set.upgrade_service_list.forEach(service => {
                                    if (service.course_category_id !== -1) {
                                        const found = category_data.find(el => el.id === service.course_category_id);
                                        service.category_name = found?.name || '';
                                    }
                                })
                            })
                        })
                    }
                }

                return list;
            }
            this.GetUserMonthQuota = async function (user_id, given_date = '', booking_id = -1) {
                try {
                    let orders = [];
                    if (DataValid(booking_id) && booking_id > -1) {
                        // 如果有booking，攞booking張order
                        const getBooking = await this.GetBookingById(booking_id);
                        if (DataValid(getBooking.order_id) && getBooking.order_id > -1) {
                            const getOrder = await this.GetOrderById(getBooking.order_id);
                            orders = [getOrder];
                        }
                    } else {
                        // 所有在期限內的packages，包括冇曬quota的packages
                        let payload = {
                            student_id: user_id,
                        };
                        if (given_date) {
                            if (given_date.length > 10) {
                                payload["date"] = given_date.substring(0, 10);
                                payload["time"] = given_date.substring(11, 19);
                            } else {
                                payload["date"] = given_date;
                                payload["time"] = "00:00:00";
                            }
                        } else {
                            const nowDatetime = serverTimeFunc.getServerCurrentTime();
                            payload["date"] = nowDatetime.substring(0, 10);
                            payload["time"] = nowDatetime.substring(11, 19);
                        }
                        const data = await Vue.prototype.$XHR.api('get_month_quota', payload);
                        if (DataValid(data.orders) && data.orders.length > 0) {
                            orders = data.orders.map(parseOrderData);
                        }
                    }

                    if (orders.length) {
                        let now = strtotime(Vue.prototype.$formatter.formatDate(serverTimeFunc.getLocalCurrentDateObj()));
                        if (given_date) now = strtotime(given_date);

                        // 搵in period嘅package
                        // 未開始有booking嘅月票order唔會有start_date, end_date
                        const get_package = await _parseMonthPackageOrder(orders, now, false, true, booking_id);
                        if (get_package.length) {
                            devLog('----------> XHR [SUCCESS]: GetUserMonthQuota');
                            devLog(get_package);
                            return Promise.resolve(get_package);
                        }
                    }

                    devLog('----------> XHR [NULL]: GetUserMonthQuota');
                    return Promise.resolve([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserMonthQuota');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetBirthdayUser = async function (center_id) {
                let payload = {center_id:center_id};

                try {
                    const data = await Vue.prototype.$XHR.api('get_birthday_students', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetBirthdayUser');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetBirthdayUser');
                        devLog(data);
                        return Promise.resolve(0);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBirthdayUser');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetUserLatestMonthPackages = async function (user_id, by_month = false, center_id = -1) {
                try {
                    const payload = {
                        filter_item: [
                            { key: 'student_id', value: user_id },
                            { key: 'status', value: 'paid' },
                            { key: 'type', value: 'month' }
                        ]
                    }

                    if (center_id !== -1) {
                        payload.center_id = center_id
                    }
                    const { data } = await this.GetOrders(payload);
                    if (data.length > 0) {
                        const now = strtotime(serverTimeFunc.getServerCurrentTime());

                        // 進行中/未來package
                        const get_package = await _parseMonthPackageOrder(data, now, true, by_month);
                        if (get_package.length > 0) {
                            devLog('----------> XHR [SUCCESS]: GetUserLatestMonthPackages');
                            devLog(get_package);
                            return Promise.resolve(get_package);
                        }
                    }

                    devLog('----------> XHR [NULL]: GetUserLatestMonthPackages');
                    devLog(data);
                    return Promise.resolve([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserLatestMonthPackages');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }

            this.GetUserUpgradeAvailableCreditPackages = async function (user_id) {
                try {
                    const uploaded = {
                        student_id: user_id
                    }

                    const data = await Vue.prototype.$XHR.api('get_user_upgrade_avail_credit_package', uploaded);
                    if (data) {
                        const formattedData = data.map(parseOrderData);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: GetUserUpgradeAvailableCreditPackages');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    devLog('----------> XHR [NULL]: GetUserUpgradeAvailableCreditPackages');
                    devLog(data);
                    return Promise.resolve([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserUpgradeAvailableCreditPackages');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }

            this.GetUserUpgradeAvailableDollarPackages = async function (user_id) {
                try {
                    const uploaded = {
                        student_id: user_id
                    }

                    const data = await Vue.prototype.$XHR.api('get_user_upgrade_avail_dollar_package', uploaded);
                    if (data) {
                        const formattedData = data.map(parseOrderData);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: GetUserUpgradeAvailableDollarPackages');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    devLog('----------> XHR [NULL]: GetUserUpgradeAvailableDollarPackages');
                    devLog(data);
                    return Promise.resolve([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserUpgradeAvailableDollarPackages');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }

            this.GetUserAttendances = async function (user_id, filters) {
                const filterItems = [
                    ...filters['filter_item'],
                    { key: 'student_id', value: user_id }
                ];
                delete filters['filter_item'];

                try {
                    const data = await this.GetBookings({
                        filter_item: filterItems,
                        ...filters
                    });
                    const returnedData = {
                        data: data['data'],
                        total: data['total'],
                        attend: data['data'].filter(el => el.attend_status === 'attend').length,
                        absent: data['data'].filter(el => el.attend_status === 'absent').length,
                        pending: data['data'].filter(el => el.attend_status === 'pending').length,
                    };
                    devLog('----------> XHR [SUCCESS]: GetUserAttendances');
                    devLog(returnedData)
                    return Promise.resolve(returnedData);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserAttendances');
                    devLog(res);
                    return Promise.reject([])
                }
            }





            /**
            * 繳費
            * ==== Required ====
            * discount_type: 'percentage' | 'fix_amount'
            * if discount_type = 'percentage' --> Math.ceil(price * (discount_value/100) * 10) / 10
            * @param {Array<{id: -1, discount_type: '', discount_value: 0, amount: 0 (qty)}>} product_id_list
            * @param {Number} subtotal - can edit
            * @param {Number} center_id
            * @param {Number} user_id
            * @param {String} status - if payment_status = "partially_paid", status = "paid"
            * @param {String} payment_status
            * @param {amount: 0, payment_method: '', payment_image: '', remark: ''} payment_detail
            * @param {Array<{role: '', staff: -1, commission: 0}>} staffs
            * ==== Optional ====
            * for extend, start_date = current 月票 `${end_date + 1}T00:00:00Z`
            * @param {Array<{id: -1, count: 0, start_date: '' }>} package_id_list - if have
            * @param {String} discount_type
            * @param {Number} discount_value
            * @param {String} remark
            * * if status == 'paid'
            * @param {String} pay_date - [YYYY-MM-DD]T[HH:MM:SS]Z
            */
            this.NewOrder = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ORDER_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_payment_order', uploaded);
                    if (data.orders && Array.isArray(data.orders) && data.orders.length > 0) {
                        const formattedData = parseOrderGroupData(data);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: NewOrder');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    devLog('----------> XHR [NULL]: NewOrder');
                    return Promise.reject('message.errorOccur');
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'package get fail':
                            return Promise.reject('message.packageNotFound');
                        case 'type not match':
                            return Promise.reject('message.selectPackageTypeShouldBeSame');
                        case 'product get fail':
                        case 'product not found':
                            return Promise.reject('message.productNotFound');
                        case 'product out of inventory':
                            return Promise.reject('message.outOfStock');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
             * ==== Optional ====
             * @param {string} payment_method
             * @param {string} payment_image
             * @param {string} status
             * @param {string} remark - remark of order
             * @param {string} payment_status
             * @param {index: -1, remark: ''} payment_detail
             * @param {Array<{role: '', staff: -1, commission: 0}>} staffs
             */
            this.UpdateOrder = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, ORDER_MODEL);
                    const get_order = await this.GetOrderById(id, true);

                    // 將最update嘅 payment_method/payment_image/remark update落最新嘅payment record
                    if (DataValid(get_order.payment_records) && get_order.payment_records.length > 0) {
                        const temp = JSON.parse(JSON.stringify(get_order.payment_records));
                        const sort = get_order.payment_records.sort((a, b) => b.index - a.index);
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i].index === sort[0].index) {
                                if (update['payment_method'] !== undefined) {
                                    temp[i]['payment_method'] = update['payment_method'];
                                }

                                if (update['payment_image'] !== undefined) {
                                    temp[i]['payment_image'] = update['payment_image'];
                                }
                            }

                            if (update['payment_detail'] !== undefined) {
                                if (temp[i].index === update['payment_detail']['index']) {
                                    temp[i].remark = update['payment_detail']['remark'];
                                }
                            }
                        }
                        formattedPayload['payment_records'] = temp;

                        if (update['payment_status'] !== undefined &&
                            DataValid(get_order.upgrade_fee) &&
                            get_order.upgrade_fee.length > 0 &&
                            get_order.upgrade_fee[get_order.upgrade_fee.length - 1]['payment_status'] !== 'paid'
                        ) {
                            const temp = JSON.parse(JSON.stringify(get_order.upgrade_fee));
                            temp[temp.length - 1]['payment_status'] = update['payment_status'];
                            formattedPayload['upgrade_fee'] = temp;
                        } else if (formattedPayload['upgrade_fee'] !== undefined) {
                            delete formattedPayload['upgrade_fee'];
                        }

                        if (formattedPayload['payment_method'] !== undefined) {
                            delete formattedPayload['payment_method'];
                        }
                        if (formattedPayload['payment_image'] !== undefined) {
                            delete formattedPayload['payment_image'];
                        }
                    } else if (DataValid(get_order.upgrade_fee) && get_order.upgrade_fee.length > 0) {
                        const temp = JSON.parse(JSON.stringify(get_order.upgrade_fee));
                        if (update['payment_method'] !== undefined) {
                            temp[temp.length - 1]['payment_method'] = update['payment_method'];
                        }
                        if (update['payment_image'] !== undefined) {
                            temp[temp.length - 1]['payment_image'] = update['payment_image'];
                        }
                        if (update['payment_status'] !== undefined && temp[temp.length - 1]['payment_status'] !== 'paid') {
                            temp[temp.length - 1]['payment_status'] = update['payment_status'];
                        }
                        formattedPayload['upgrade_fee'] = temp;

                        if (formattedPayload['payment_method'] !== undefined) {
                            delete formattedPayload['payment_method'];
                        }
                        if (formattedPayload['payment_image'] !== undefined) {
                            delete formattedPayload['payment_image'];
                        }
                    } else if (formattedPayload['upgrade_fee'] !== undefined) {
                        delete formattedPayload['upgrade_fee'];
                    }

                    if (formattedPayload['payment_detail'] !== undefined) {
                        delete formattedPayload['payment_detail'];
                    }

                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_order', payload);
                    const formattedData = parseOrderData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateOrder');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Optional ====
             * @param {string} status
             * @param {string} payment_status
             */
            this.UpdateOrderGroup = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, ORDER_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_payment_order', payload);
                    const formattedData = parseOrderGroupData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOrderGroup');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateOrderGroup');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrderGroup');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * 近期帳單
             * ===== Optional =====
             * @param {number} filter_page - start from 0
             * @param {number} filter_limit
             * @param {number} center_id
             * @param {Array<{key: string, value: any}>} filter_item
             * filter_item key:
             * - 'create_date': string
             * - 'id': number
             * - 'student_name': string
             * - 'phone': string
             * - 'student_id': number
             */
            this.GetOrders = async function (filters = {}) {
                const payload = {
                    data_type: 'order_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseOrderData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetOrders');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrders');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrders');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetMonthOrder = async function (filters = {}) {
                let join_code = false;
                const payload = {
                    data_type: 'month_order_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                if (payload['join_code'] !== undefined) {
                    join_code = payload['join_code'];
                    delete payload['join_code'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let centerList = [];
                        if (join_code) {
                            const idList = data['data'].map(el => el[ORDER_MODEL.center_id]);
                            centerList = await GetCentersByIdList(idList);
                        }
                        const formattedData = data['data'].map(el => parseMonthOrderGroupData(el, centerList));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetOrderGroups');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderGroups');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderGroups');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            this.GetOrderGroups = async function (filters = {}) {
                let join_code = false;
                const payload = {
                    data_type: 'payment_order_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                if (payload['join_code'] !== undefined) {
                    join_code = payload['join_code'];
                    delete payload['join_code'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let centerList = [];
                        if (join_code) {
                            const idList = data['data'].map(el => el[ORDER_MODEL.center_id]);
                            centerList = await GetCentersByIdList(idList);
                        }
                        const formattedData = data['data'].map(el => parseOrderGroupData(el, centerList));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetOrderGroups');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderGroups');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderGroups');
                    devLog(res);
                    return Promise.reject([])
                }
            }
            const GetOrderGroupsByIdList = async function (id_list, filters = {}) {
                let join_code = false;
                const payload = {
                    data_type: 'payment_order_data',
                    id_list: id_list,
                    ...filters
                };
                if (payload['join_code'] !== undefined) {
                    join_code = payload['join_code'];
                    delete payload['join_code'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        let centerList = [];
                        if (join_code) {
                            const idList = data.map(el => el[ORDER_MODEL.center_id]);
                            centerList = await GetCentersByIdList(idList);
                        }

                        const formattedData = data.map(el => parseOrderGroupData(el, centerList));
                        devLog('----------> XHR [SUCCESS]: GetOrderGroupsByIdList');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderGroupsByIdList');
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderGroupsByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetOrderById = async function (id, keepRaw = false) {
                const payload = {
                    data_type: 'order_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    let formattedData = data;
                    if (!keepRaw) {
                        formattedData = parseOrderData(data);
                    }
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetOrderGroupById = async function (id, center_id = -1) {
                const payload = {
                    data_type: 'payment_order_data',
                    id: id
                };

                if (center_id !== -1) {
                    payload.center_id = center_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseOrderGroupData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderGroupById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderGroupById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderGroupById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            const GetOrderGroupByOrderId = async function (order_id, join_code = false) {
                const payload = {
                    id: order_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_payment_order_by_order_id', payload);
                    let centerData = [];
                    if (join_code) {
                        if (data.orders.length > 0) {
                            centerData = await GetCentersByIdList([data.orders[0][ORDER_MODEL.center_id]]);
                        }
                    }
                    const formattedData = parseOrderGroupData(data, centerData);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderGroupByOrderId');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderGroupByOrderId');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderGroupByOrderId');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ExportOrderReport = async function (filter = {}) {
                const payload = {
                    ...filter
                };

                try {
                    const data = await Vue.prototype.$XHR.api('order_report', payload);
                    devLog('----------> XHR [SUCCESS]: ExportOrderReport');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportOrderReport');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ExportOrderInvoice = async function (order_group_id, index = -1) {
                let payload = {
                    id: order_group_id,
                };

                if (index > -1) {
                    payload['invoice_pick'] = index;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('export_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: ExportOrderInvoice');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportOrderInvoice');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ExportRefundOrderInvoice = async function (order_id) {
                const payload = {
                    id: order_id,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('export_debit_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: ExportRefundOrderInvoice');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportRefundOrderInvoice');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetDebitCreditDollarList = async function (payment_order_id) {
                try {
                    const payload = {
                        payment_order_id
                    }

                    const data = await Vue.prototype.$XHR.api('get_debit_credit_dollar_list', payload);
                    devLog('----------> XHR [SUCCESS]: GetDebitCreditDollarList');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetDebitCreditDollarList');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Required ====
             * @param {number} refund_value - for type "credit" / "dollar"
             * @param {} package_data - for type "month" 完整package data
             * @param {} quota - for type "month"
             * @param {number} debit_amount
             * @param {string} debit_remark
             * @param {Array<{ id: -1, amount: 0 }>} debit_product_ids
             * 
             * 月票 quota
             * 由第一個object開始減起
             * 如果有booking，唔比remove個treatment quota
             * 如果個set quota啲treatment quota冇曬，該quota[i] set做null（通常不會出現呢個狀況）
             * 
             */
            // this.RefundOrder = async function (order_id, update) {
            //     try {
            //         const payload = {
            //             id: order_id,
            //             ...update
            //         }

            //         const data = await Vue.prototype.$XHR.api('debit_order', payload);
            //         devLog('----------> XHR [SUCCESS]: RefundOrder');
            //         devLog(data)
            //         return Promise.resolve(data);
            //     } catch (res) {
            //         devLog('----------> XHR [FAIL]: RefundOrder');
            //         devLog(res);
            //         switch (res.data) {
            //             case 'order not found':
            //                 return Promise.reject('message.orderMissing');
            //             case 'order cannot debit':
            //                 return Promise.reject('message.unpaidOrderCannotRefund');
            //             case 'package used and cannot debit':
            //                 return Promise.reject('message.packageUsedCannotVoid');
            //             case 'credit not enough':
            //                 return Promise.reject('message.creditNotEnough');
            //             case 'dollar not enough':
            //                 return Promise.reject('message.dollarNotEnough');
            //             case 'debit amount over order amount':
            //                 return Promise.reject('message.refundAmountExceedOrderTotal');
            //             default:
            //                 return Promise.reject(displayError(res));
            //         }
            //     }
            // }

            /**
              * ==== Required ====
              * @param {Array<{order_id:number,refund_value:number}>} refund_value_list - for type "credit"
              * @param {Array<{order_id:number,refund_value:number}>} refund_dollar_list - for type "dollar"
              * @param {} package_data - for type "month" 完整package data
              * @param {} quota - for type "month"
              * @param {number} debit_amount
              * @param {string} debit_remark
              * @param {Array<{ id: -1, amount: 0 }>} debit_product_ids
              */
            this.RefundOrderGroup = async function (order_group_id, update) {
                try {
                    const payload = {
                        id: order_group_id,
                        ...update
                    }

                    const data = await Vue.prototype.$XHR.api('debit_payment_order', payload);
                    devLog('----------> XHR [SUCCESS]: RefundOrderGroup');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RefundOrderGroup');
                    devLog(res);
                    switch (res.data) {
                        case 'order not found':
                            return Promise.reject('message.orderMissing');
                        case 'order cannot debit':
                            return Promise.reject('message.unpaidOrderCannotRefund');
                        case 'package used and cannot debit':
                            return Promise.reject('message.packageUsedCannotVoid');
                        case 'credit not enough':
                            return Promise.reject('message.creditNotEnough');
                        case 'dollar not enough':
                            return Promise.reject('message.dollarNotEnough');
                        case 'debit amount over order amount':
                            return Promise.reject('message.refundAmountExceedOrderTotal');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.VoidOrder = async function (order_id) {
                try {
                    const payload = {
                        id: order_id,
                    }

                    const data = await Vue.prototype.$XHR.api('void_order', payload);
                    devLog('----------> XHR [SUCCESS]: VoidOrder');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: VoidOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'order not found':
                            return Promise.reject('message.orderMissing');
                        case 'lesson already attended':
                            return Promise.reject('message.attendBookingCannotVoid');
                        case 'credit used':
                            return Promise.reject('message.creditUsedCannotVoid');
                        case 'dollar used':
                            return Promise.reject('message.dollarUsedCannotVoid');
                        case 'order cannot void':
                            return Promise.reject('message.unpaidMonthPackageExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.VoidOrderGroup = async function (order_group_id) {
                try {
                    const payload = {
                        id: order_group_id,
                    }

                    const data = await Vue.prototype.$XHR.api('void_payment_order', payload);
                    devLog('----------> XHR [SUCCESS]: VoidOrderGroup');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: VoidOrderGroup');
                    devLog(res);
                    switch (res.data) {
                        case 'order not found':
                            return Promise.reject('message.orderMissing');
                        case 'lesson already attended':
                            return Promise.reject('message.attendBookingCannotVoid');
                        case 'credit used':
                            return Promise.reject('message.creditUsedCannotVoid');
                        case 'dollar used':
                            return Promise.reject('message.dollarUsedCannotVoid');
                        case 'order cannot void':
                            return Promise.reject('message.unpaidMonthPackageExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
            * 取代現有月票
            * ==== Required ====
            * @param {} quota - 新quota data，個service_detail_list要extend咗
            * @param {} package_data - 新package data
            * @param {number} upgrade_fee - 會save係order "upgrade_fee"
            * @param {string} payment_image - 會save係order "upgrade_fee"
            * @param {string} payment_method - 會save係order "upgrade_fee"
            * @param {number} center_id
            * @param {string} remark
            * @param {string} status
            * @param {number} package_id
            * // -- for create new payment
            * @param {number} payment_amount
            */
            this.UpgradeOrderMonthPackage = async function (order_id, payload) {
                try {
                    // ---------- Upgrade Package ----------
                    const _payload = JSON.parse(JSON.stringify(payload));
                    if (_payload['payment_amount'] !== undefined) {
                        delete _payload['payment_amount'];
                    }

                    await Vue.prototype.$XHR.api('upgrade_order', {
                        id: order_id,
                        ..._payload
                    });

                    // ---------- New Payment ----------
                    // -- Get order group
                    const get_order_group = await GetOrderGroupByOrderId(order_id);

                    // -- add new payment record
                    let payment_records = [];
                    if (DataValid(get_order_group.payment_records) && get_order_group.payment_records.length > 0) {
                        payment_records = JSON.parse(JSON.stringify(get_order_group.payment_records));
                    }
                    let new_index = 1;
                    if (payment_records.length) {
                        const sort = payment_records.sort((a, b) => b.index - a.index);
                        new_index = sort[0].index + 1;
                    }
                    payment_records.push({
                        index: new_index,
                        amount: payload.payment_amount,
                        date: Vue.prototype.$formatter.formatDate(serverTimeFunc.getLocalCurrentDateObj()),
                        payment_image: payload.payment_image,
                        payment_method: payload.payment_method,
                        remark: payload.remark,
                    })

                    let order_payload = {
                        id: get_order_group.main_order_id,
                        payment_records: payment_records,
                    }

                    // -- update payment_status if fully paid
                    let payment_status = payload.status;
                    const total_paid = payment_records.reduce((value, item) => value + item.amount, 0);
                    if (payload['status'] === 'paid') {
                        if (total_paid < get_order_group.real_total) {
                            payment_status = 'partially_paid';
                        }
                    }
                    order_payload['payment_status'] = payment_status;

                    await Vue.prototype.$XHR.api('edit_order', order_payload);
                    if (order_payload['status'] || order_payload['payment_status']) {
                        let paymentPayload = {
                            id: get_order_group.id,
                        }
                        if (order_payload['status']) paymentPayload['status'] = order_payload['status'];
                        if (order_payload['payment_status']) paymentPayload['payment_status'] = order_payload['payment_status'];

                        await Vue.prototype.$XHR.api('edit_payment_order', paymentPayload);
                    }

                    devLog('----------> XHR [SUCCESS]: UpgradeOrderMonthPackage');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpgradeOrderMonthPackage');
                    devLog(res);
                    switch (res.data) {
                        case 'order not found':
                            return Promise.reject('message.orderMissing');
                        case 'order cannot upgrade':
                            return Promise.reject('message.unpaidMonthPackageExist');
                        case 'package used and cannot upgrade':
                            return Promise.reject('message.newPackageNoMatchCurrentPackage');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
            * 轉格仔/value套票
            *  * ==== Required ====
            * @param {number} deduct_amount - 舊package扣除格仔/Value數量
            * @param {number} upgrade_fee - 新package價錢(可edit)
            * @param {string} payment_image - 會save係order "upgrade_fee"
            * @param {string} payment_method - 會save係order "upgrade_fee"
            * @param {number} center_id
            * @param {string} remark
            * @param {string} status
            * @param {number} package_id
            * @param {number} payment_amount
            * @param {number} old_package_id
            */
            this.UpgradeOrderCreditDollarPackage = async function (order_id, payload) {
                try {
                    // ---------- Upgrade Package ----------
                    const _payload = JSON.parse(JSON.stringify(payload));

                    await Vue.prototype.$XHR.api('upgrade_credit_dollar_package_order', {
                        order_id,
                        ..._payload
                    });

                    devLog('----------> XHR [SUCCESS]: UpgradeOrderCreditDollarPackage');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpgradeOrderCreditDollarPackage');
                    devLog(res);
                    switch (res.data) {
                        case 'order not found':
                            return Promise.reject('message.orderMissing');
                        case 'order cannot upgrade':
                            return Promise.reject('message.unpaidPackageExist');
                        case 'package used and cannot upgrade':
                            return Promise.reject('message.newCreditDollarPackageNoMatchCurrentPackage');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }


            /**
             * ==== Required ====
             * @param {number} amount
             * @param {string} date
             * @param {string} payment_image
             * @param {string} payment_method
             * @param {string} remark
             */
            this.NewOrderPayment = async function (order_group_id, update) {
                try {
                    const get_order_group = await this.GetOrderGroupById(order_group_id);

                    // -- add new payment record
                    let payment_records = [];
                    if (DataValid(get_order_group.raw_payment_records) && get_order_group.raw_payment_records.length > 0) {
                        payment_records = JSON.parse(JSON.stringify(get_order_group.raw_payment_records));
                    }
                    let new_index = 1;
                    if (payment_records.length) {
                        const sort = payment_records.sort((a, b) => b.index - a.index);
                        new_index = sort[0].index + 1;
                    }
                    payment_records.push({
                        index: new_index,
                        amount: update.amount,
                        date: update.date,
                        payment_image: update.payment_image,
                        payment_method: update.payment_method,
                        remark: update.remark,
                    })

                    let payload = {
                        id: get_order_group.main_order_id,
                        payment_records: payment_records,
                    }

                    // -- update payment_status if fully paid
                    const total_paid = payment_records.reduce((value, item) => value + item.amount, 0);
                    if (total_paid > 0 && (get_order_group.status === 'paid' || get_order_group.status === 'partially_paid' || get_order_group.status === 'pending' || get_order_group.status === 'processing')) {
                        payload['status'] = 'paid';

                        if (total_paid >= get_order_group.real_total) {
                            payload['payment_status'] = 'paid';
                        }
                    }

                    await Vue.prototype.$XHR.api('edit_order', payload);
                    if (payload['status'] || payload['payment_status']) {
                        let paymentPayload = {
                            id: order_group_id,
                        }
                        if (payload['status']) paymentPayload['status'] = payload['status'];
                        if (payload['payment_status']) paymentPayload['payment_status'] = payload['payment_status'];


                        await Vue.prototype.$XHR.api('edit_payment_order', paymentPayload);
                    }

                    devLog('----------> XHR [SUCCESS]: NewOrderPayment');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOrderPayment');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Required ====
             * @param {number} extend_month
             */
            this.ExtendMonthlyPackage = async function (order_id, update) {
                try {
                    const payload = {
                        order_id,
                        ...update
                    }

                    const data = await Vue.prototype.$XHR.api('extend_package_order', payload);
                    devLog('----------> XHR [SUCCESS]: ExtendMonthlyPackage');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExtendMonthlyPackage');
                    devLog(res);
                    switch (res.data) {
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
             * ==== Required ====
             * @param {number} deduct_month
             */
            this.DeductMonthlyPackage = async function (order_id, update) {
                try {
                    const payload = {
                        order_id,
                        ...update
                    }

                    const data = await Vue.prototype.$XHR.api('deduct_package_order', payload);
                    devLog('----------> XHR [SUCCESS]: DeductMonthlyPackage');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeductMonthlyPackage');
                    devLog(res);
                    switch (res.data) {
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            this.ExportReport = async function (key, payload) {
                try {
                    const data = await Vue.prototype.$XHR.api(key, payload);
                    devLog('----------> XHR [SUCCESS]: ExportReport');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportReport');
                    devLog(res);
                    return Promise.reject('message.noDataCanExport');
                    // switch (res.data) {
                    //     default:
                    //         return Promise.reject(displayError(res));
                    // }
                }
            }




            /**
             * ==== Required ====
             * @param {string} filter - today | week | month | custom
             */
            this.GetDashboard = async function (filter = {}) {
                try {
                    const data = await Vue.prototype.$XHR.api('dashboard', filter);
                    devLog('----------> XHR [SUCCESS]: GetDashboard');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetDashboard');
                    devLog(res);
                    switch (res.data) {
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }



            /**
            * 同意書
            * ===== Optional =====
            * @param {number} filter_page - start from 0
            * @param {number} filter_limit
            */
            this.GetAgreements = async function (filters = {}) {
                const payload = {
                    data_type: 'agreement_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseAgreementData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetAgreements');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetAgreements');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAgreements');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            /**
            * 新增同意書
            * ======== Required ========
            * @param {string} name
            * @param {string} content
            * ======== Optional ========
            * @param {string} remark
            */
            this.NewAgreement = async function (payload) {
                if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                    delete payload['active'];
                }

                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, AGREEMENT_MODEL);
                    const uploaded = {
                        ...formattedPayload,
                        count: 0
                    }

                    const data = await Vue.prototype.$XHR.api('new_agreement', uploaded);
                    const formattedData = parseAgreementData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewAgreement');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewAgreement');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewAgreement');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateAgreement = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, AGREEMENT_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_agreement', payload);
                    const formattedData = parseAgreementData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateAgreement');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateAgreement');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateAgreement');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetAgreementById = async function (id) {
                const payload = {
                    data_type: 'agreement_data',
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseAgreementData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetAgreementById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetAgreementById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAgreementById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.DeleteAgreement = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_agreement', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteAgreement');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteAgreement');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetStudentAgreementList = async function (student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_student_agreement_list', { student_id });
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(el => parseAgreementData(el, el.sign_data));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStudentAgreementList');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetStudentAgreementList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentAgreementList');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            this.ExportAgreementPDF = async function (agreement_id, student_id) {
                let payload = {
                    agreement_id,
                    student_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('gen_agreement_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: ExportAgreementPDF');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportAgreementPDF');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
            * 新增排更代碼
            * ======== Required ========
            * @param {string} code
            * @param {string} color
            * @param {Array<{start_time:string, end_time:string}>} color
            */
            this.NewShiftCode = async function (payload, center_id = -1) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, SHIFT_CODE_MODEL);
                    const uploaded = {
                        ...formattedPayload,
                        center_id
                    }

                    const data = await Vue.prototype.$XHR.api('new_shift', uploaded);
                    const formattedData = parseShiftCodeData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewShiftCode');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: NewShiftCode');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewShiftCode');
                    devLog(res);
                    switch (res.data) {
                        case 'time overlap':
                            return Promise.reject('message.timeCannotOverlap');
                        case 'duplicate shift code':
                            return Promise.reject('message.duplicateShiftCode');
                        case 'empty time list':
                            return Promise.reject('message.addAtLeastOneTime');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.UpdateShiftCode = async function (id, update, center_id) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, SHIFT_CODE_MODEL);
                    const payload = {
                        id: id,
                        center_id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('update_shift', payload);
                    const formattedData = parseShiftCodeData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateShiftCode');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateShiftCode');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateShiftCode');
                    devLog(res);
                    switch (res.data) {
                        case 'time overlap':
                            return Promise.reject('message.timeCannotOverlap');
                        case 'duplicate shift code':
                            return Promise.reject('message.duplicateShiftCode');
                        case 'empty time list':
                            return Promise.reject('message.addAtLeastOneTime');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.UpdateShiftCodeOrder = async function (id_list, center_id) {
                try {
                    const payload = {
                        shift_id_list: id_list,
                        center_id
                    }

                    const data = await Vue.prototype.$XHR.api('update_shift_order', payload);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateShiftCodeOrder');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateShiftCodeOrder');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateShiftCodeOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.DeleteShiftCode = async function (id, center_id) {
                try {
                    await Vue.prototype.$XHR.api('delete_shift', { id, center_id });
                    devLog('----------> XHR [SUCCESS]: DeleteShiftCode');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteShiftCode');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetShiftCodeById = async function (id, center_id) {
                const payload = {
                    data_type: 'shift_data',
                    center_id,
                    id: id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseShiftCodeData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetShiftCodeById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetShiftCodeById');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetShiftCodeById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetShiftCodeList = async function (center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', { data_type: 'shift_data', center_id, order_by: 'order' });
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(el => parseShiftCodeData(el));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetShiftCodeList');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetShiftCodeList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetShiftCodeList');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            /**
             * ===== Optional =====
             * @param {number} filter_page - start from 0
             * @param {number} filter_limit
             * @param {number} center_id
             * @param {Array<{key: string, value: any}>} filter_item
             */
            this.GetRawShiftSettingList = async function (filters = {}) {
                const payload = {
                    data_type: 'shift_setting_data',
                    ...filters
                };
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseShiftSettingData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetRawShiftSettingList');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    } else {
                        devLog('----------> XHR [NULL]: GetRawShiftSettingList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetRawShiftSettingList');
                    devLog(res);
                    return Promise.reject([]);
                }
            }

            // for ShiftControl page only
            this.GetShiftSettingList = async function (payload, center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_shift_setting_list', { ...payload, center_id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetShiftSettingList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetShiftSettingList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetShiftSettingList');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            this.UpsertSettingList = async function (payload, center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('upsert_shift_setting_list', { ...payload, center_id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpsertSettingList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UpsertSettingList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpsertSettingList');
                    devLog(res);
                    switch (res.data) {
                        case "timeslot overlap":
                            return Promise.reject('message.timeCannotOverlap');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.RemoveShiftSetting = async function (payload) {
                try {
                    const data = await Vue.prototype.$XHR.api('remove_shift_setting', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: RemoveShiftSetting');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: RemoveShiftSetting');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveShiftSetting');
                    devLog(res);
                    switch (res.data) {
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.GetShiftStaffCountList = async function (payload, center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_shift_staff_count_list', { ...payload, center_id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetShiftStaffCountList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetShiftStaffCountList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetShiftStaffCountList');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            this.GetShiftHourCountList = async function (payload, center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_shift_hour_count_list', { ...payload, center_id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetShiftHourCountList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetShiftHourCountList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetShiftHourCountList');
                    devLog(res);
                    return Promise.reject([])
                }
            }

            this.GetDailyShiftHourList = async function (payload, center_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_daily_shift_hour_list', { ...payload, center_id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetDailyShiftHourList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetDailyShiftHourList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetDailyShiftHourList');
                    devLog(res);
                    return Promise.reject([])
                }
            }


            this.GetServerTime = async function () {
                try {
                    const url = process.env.VUE_APP_API_LINK.replace("request.php", "server_time.php");
                    const data = await Vue.prototype.$XHR.get(url);
                    devLog('----------> XHR [SUCCESS]: GetServerTime');
                    devLog(data)
                    return Promise.resolve(data);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetServerTime');
                    devLog(res);
                    return Promise.reject("")
                }
            }
        })()
    }
}